<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
			<consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa" v-bind:incmassa="true"></consultaprodutos>
            <consultaclientes></consultaclientes>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="MtdCancelarEdicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-12 col-sm-12 col-md-2 col-lg-2">
								<label for="edidpedidopesq">Nr. Agendamento:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'###############'" class="form-control form-control-sm" v-model="pidagendamentopet" @keydown="MtdLimparListagem()">
                            </div>  
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilialpet" data-allow-clear="true" style="width:100%;">
								</select>
							</div>     
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidclientepet" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                    
							<div class="col-12 col-sm-12 col-md-2 col-lg-2">
								<label for="edidpedidopesq">Chip pet:</label>
								<input id="edidpedidopesq" type="text" class="form-control form-control-sm" v-model="pchippet" @keydown="MtdLimparListagem()">
							</div>  
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="MtdLimparListagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>     
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo" @change="MtdLimparListagem()">
									<option value="0">Emissão</option>
									<option value="1">Agendamento</option>
								</select>
							</div>     
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                     
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">St. Agendamento:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="pstagendamentopet" @change="MtdLimparListagem()">
									<option value="0">Agendado</option>
									<option value="1">Remarcado</option>
									<option value="2">Cancelado</option>
									<option value="3">Todos</option>
								</select>
                            </div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">St. Pagamento:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="pstpagamentopet" @change="MtdLimparListagem()">
									<option value="0">Aberto</option>
									<option value="1">Faturado</option>
									<option value="2">Cancelado</option>
									<option value="3">Todos</option>
								</select>
                            </div>                                                        
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="MtdLimparListagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="MtdExecutaPesquisa()"><i class="fa fa-search"></i></button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstagendamentoss"
                                        :rows="lstagendamentos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ MtdFormatarZeros(item.row.idagendamento, 8) }} </span>
                                        <!-- <i v-if="parseInt(item.row.liberarpdv) === 1" class="fa fa-unlock" style="color: #5A956A;" title="Liberado para o PDV"></i>
										<i v-else class="fa fa-lock" style="color: #EEA435;" title="Bloqueado para o PDV"></i> -->
										<i v-if="parseInt(item.row.liberarpdv) === 1" @dblclick="MtdRotinaPdv(item.row.idagendamento, item.row)" class="fa fa-unlock icone-libera-pdv" style="color: #5A956A;" title="Liberado para o PDV (clique duas vezes para bloquear)"></i>
										<i v-else class="fa fa-lock icone-libera-pdv" style="color: #EEA435;" @dblclick="MtdRotinaPdv(item.row.idagendamento, item.row)" title="Bloqueado para o PDV (clique duas vezes para desbloquear)"></i>
                                    </template>
                                    <template slot="slot_dtentrega" slot-scope="item">
                                        <span v-show="parseInt(item.row.entregapet) === 1" style="color: #6c757d; font-size: 12px;">{{ item.row.dtentrega }}</span>
                                    </template>                                                                    
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtemissao }}</span>
                                    </template>                                                                    
                                    <template slot="slot_dtagendamento" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtagendamento }}</span>
                                    </template>                                                                    
                                    <template slot="slot_stagendamento" slot-scope="item">
                                        <span v-if="parseInt(item.row.stagendamento) === 0"      class="badge badge-pill badge-primary bdg-agendado" style="">Agendado</span>
                                        <span v-else-if="parseInt(item.row.stagendamento) === 1" class="badge badge-pill badge-primary bdg-remarcado">Remarcado</span>
                                        <span v-else-if="parseInt(item.row.stagendamento) === 2" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
									<!-- <template v-if="parseInt(item.row.idpedido) > 0" slot="slot_stpagamento" slot-scope="item">
										<span v-if="parseInt(item.row.stpagamento) === 0"      class="badge badge-pill badge-primary bdg-aberto" style="">Aberto</span>
										<span v-else-if="parseInt(item.row.stpagamento) === 1" class="badge badge-pill badge-primary bdg-faturado">Faturado</span>
										<span v-else-if="parseInt(item.row.stpagamento) === 2" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
									</template>                                                                    -->
									<template  slot="slot_stpagamento" slot-scope="item">
										<span v-if="parseInt(item.row.stpedido) 	 === 0" class="badge badge-pill badge-primary bdg-aberto">Aberto</span>
										<span v-else-if="parseInt(item.row.stpedido) === 1" class="badge badge-pill badge-danger bdg-faturado">Faturado</span>
										<span v-else-if="parseInt(item.row.stpedido) === 2" class="badge badge-pill badge-warning bdg-cancelado">Cancelado</span>
									</template> 
                                    <template slot="slot_totalgeral" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: bold;">{{ MtdFormataValorDecimal(parseFloat(item.row.totalgeral), 2) }}</span>
                                    </template>                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="flex">
											<button type="button" class="btn btn-primary btn-sm" @click.prevent="MtdMostrarMenu(item.row)" style="width: 35px;">
												<i class="fa fa-navicon"></i>
											</button>
                                        </div>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-6">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstagendamentos.length}}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Total
                                        <span class="badge badge-primary bdg-totais" style="background-color: #f82b54;">{{ MtdFormataValorDecimal(ptotalcusto, 2) }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-6 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="MtdNovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="MtdCancelarEdicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
						<div class="row">
							<div :class="{'col-md-10' : vpet, 'col-md-12' : !vpet}" style="margin-bottom: 15px;">
								<div class="row"> 
									<div class="col-sm-12 col-md-3 col-lg-2">
										<label for="edid">Nr. Agendamento:</label>
										<input type="text" class="form-control form-control-sm" id="edid" v-model="vidagendamentopet"
											disabled  maxlength="20"/>
									</div>
									<div class="col-sm-12 col-md-9 col-lg-4">
										<span class="lblselect2">*Filial:</span>
										<select id="cbfilialpet" data-placeholder="Selecione uma filial" v-model="vidfilialpet" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
										</select>
									</div>
									<div class="col-sm-12 col-md-3 col-lg-2">
										<label for="eddtemissao">Dt. Emissão:</label>
										<div class="input-group">
											<date-picker id="eddtemissao" v-model="vdtemissaopet" :config="options"
												class="form-control form-control-sm" disabled></date-picker>
											<div class="input-group-append">
												<span class="input-group-text"><i class="fa fa-calendar"></i></span>
											</div>										
										</div>
									</div>
									<div class="col-sm-12 col-md-3 col-lg-2">
										<label for="eddtagendamento">Dt. Agendamento:</label>
										<div class="input-group">
											<date-picker id="eddtagendamento" v-model="vdtagendamentopet" :config="options" v-bind:disabled="ativadesativa"
												class="form-control form-control-sm"></date-picker>
											<div class="input-group-append">
												<span class="input-group-text"><i class="fa fa-calendar"></i></span>
											</div>										
										</div>
									</div>
									<div class="col-sm-12 col-md-2 col-lg-2">
										<label for="edhrini">Hr. Agendamento:</label>
										<input type="text" v-model="phrag" 
											class="form-control form-control-sm" id="edhrini" 
											v-mask="'##:##'" 
											@blur="ValidarHorario"
											v-bind:disabled="ativadesativa">
										<div v-if="erroHorario" class="text-danger">
											Horário inválido! Insira um horário entre 00:00 e 23:59.
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-12 col-md-2 col-lg-2">
										<label for="edcliente">*Cliente:</label>
										<div class="input-group" style="z-index: 1;">
											<input type="text" class="form-control form-control-sm" id="edcliente" v-model="vidclientepet"  maxlength="11" @change="MtdLocalizarCliente(vidclientepet)" v-bind:disabled="ativadesativa">
											<div class="input-group-append">
												<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="MtdConsultarCliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
											</div>
										</div>
									</div>
									<div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
										<label for="ednomecliente">Nome do cliente:</label>
										<div class="input-group" style="z-index: 1;">
											<input type="text" class="form-control form-control-sm" id="ednomecliente" v-model="vnomeclientepet"
												data-bv-group=".group" maxlength="50" disabled style="font-weight: bold;"/>										
										</div>	
									</div>		
									<div class="col-sm-12 col-md-6 col-lg-4">
										<span class="lblselect2">*Pet:</span>
										<select id="cbpet" data-placeholder="Selecione um pet" v-model="vpet" data-allow-clear="true" :disabled="vnomeclientepet === null || !vidclientepet" style="width:100%;" v-bind:disabled="ativadesativa">
										</select>
									</div>
									<div class="col-sm-12 col-md-3 col-lg-1">
										<label for="cbtipo">Buscar:</label>
										<select class="form-control form-control-sm" id="cbtipo" v-model="vbuscapet" v-bind:disabled="ativadesativa">
											<option value="0">Não</option>
											<option value="1">Sim</option>
										</select>
									</div>
									<!-- <div class="col-sm-12 col-md-3 col-lg-2">
										<label for="cbtipo">St. agendamento:</label>
										<select class="form-control form-control-sm" id="cbtipo" v-model="vagendamentopet" v-bind:disabled="ativadesativa" disabled>
											<option value="0">Agendado</option>
											<option value="1">Remarcado</option>
											<option value="2">Cancelado</option>
										</select>
									</div> -->
								</div>
								<div class="row">
									<!-- <div class="col-sm-12 col-md-3 col-lg-2">
										<label for="cbtipo">St. pagamento:</label>
										<select class="form-control form-control-sm" id="cbtipo" v-model="vpagamentopet" v-bind:disabled="ativadesativa" disabled>
											<option value="0">Aberto</option>
											<option value="1">Faturado</option>
											<option value="2">Cancelado</option>
										</select>
									</div> -->
									<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">                            
										<div class="custom-control custom-switch border rounded" style="margin-top: 20px;padding: 5px;">
											<input type="checkbox" class="custom-control-input" id="cbentregaexterna" v-model="ventregapet" v-bind:disabled="ativadesativa">
											<label class="custom-control-label" for="cbentregaexterna" id="lblentregar" style="margin-left: 40px;">
												Entregar<i class="fa fa-dog" id="icone-entregar" style="transform: scaleX(1);"></i>
											</label>
										</div>
									</div>
									<div class="col-sm-12 col-md-3 col-lg-2" v-show="ventregapet === true" >
										<label for="eddtemissao">*Dt. Entrega:</label>
										<div class="input-group">
											<date-picker id="eddtemissao" v-model="vdtentregapet" :config="options"
												class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
											<div class="input-group-append">
												<span class="input-group-text"><i class="fa fa-calendar"></i></span>
											</div>										
										</div>
									</div>
									<div class="col-sm-12 col-md-3 col-lg-2">
										<label for="edresponsavelpet">*Responsável:</label>
										<input type="text" class="form-control form-control-sm" id="edresponsavelpet" v-model="vresponsavelpet" maxlength="50" v-bind:disabled="ativadesativa">                                                
									</div>  
									<div class="col-sm-12 col-md-3 col-lg-2">
										<label for="edtelpet">*Tel responsável:</label>
										<input type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control form-control-sm" id="edtelpet" v-model="vtelefonepet" maxlength="100" v-bind:disabled="ativadesativa">                                                
									</div>  
									<div class="col-sm-12 col-md-3 col-lg-3 col-xl-2" id="dvplano">
										<button v-if="vidplano === null" type="button" class="btn btn-success btn-block btn-sm btn_selecionar_plano" v-bind:disabled="ativadesativa" @click.prevent="MtdSelecionarPlano()"><i class="fa fa-pencil-square-o"></i> Selecione o plano</button>
										<button v-else type="button" class="btn btn-success btn-block btn-sm btn_selecionar_plano" v-bind:disabled="ativadesativa" @click.prevent="MtdSelecionarPlano()"><i class="fa fa-pencil-square-o"></i> {{ MtdFormatarZeros(vidplano, 2) }} - {{ vdescplano }}</button>
									</div>
								</div>                             
							</div>
							<div class="col-md-2" v-show="vpet">
								<div class="col">
									<div class="row text-center" style="padding: 0px 15px 0px 15px; margin-bottom: 15px;">
										<div class="col-md-12 border rounded" style="padding: 0px;">
											<input
												type="file" 
												id="ipimgpet"
												accept="image/png, image/jpeg, image/jpg" 
												style="display: none;"
												ref="if_imgpetedicao">
											<div v-if="isLoadingimgpet" class="main-home" style="height: 155px; display: flex; align-items: center; justify-content: center;">
												<div class="spinner-border" style="width: 2rem; height: 2rem;" role="status">
													<span class="sr-only">Loading...</span>
												</div>
											</div>
											<img v-show="parseInt(opcrud) < 3 && !isLoadingimgpet" class="img-fluid img-filial" title="Clique aqui para selecionar uma imagem" :src="vimagempet === 1 ? this.$store.state.configpaths.pathimagens + 'imagens/semimagem.png' : vimagempet">  
											<img v-show= "parseInt(opcrud) === 3 && !isLoadingimgpet"  class="img-fluid img-cliente" :src="vimagempet === 1 ? this.$store.state.configpaths.pathimagens + 'imagens/semimagem.png' : vimagempet"> 
										</div>
									</div>
								</div>
							</div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvprodutos">Produtos</a>
                                    </li>
									<li class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvservicos">Serviços</a>
                                    </li>																	
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvprodutos" class="container-fluid tab-pane active">
                                        <div class="row">	
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2 ml-auto" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="MtdAdicionarItem()"><i class="fa fa-plus"></i> Adicionar ítem</button>
											</div>											
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="MtdAplicarDesconto()"><i class="fa fa-percent"></i> Aplicar Desconto <i class="fa fa-dollar"></i></button>
											</div>																																							
											<div  class="col-md-12">
												<vue-bootstrap4-table
														:rows="lstitens"
														:columns="columnsi"
														:config="config"
														:classes="classes">														
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem itens no pedido</div>
													</template>
													<!-- ícones de ordenação da table -->
													<template slot="sort-asc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-asc"></i>
													</template>
													<template slot="sort-desc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-desc"></i>
													</template>
													<template slot="no-sort-icon">
														<i class="fa-icones-ordenacao fa fa-unsorted"></i>
													</template>                                    
													<!--  -->													
													<template slot="opcoesi" slot-scope="item">
														<div style= "display: flex; justify-content: center;" >
															<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="MtdAlterarItem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
															<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="MtdExcluirItem(item.row.item)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
															<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="MtdVisualizarEstoque(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-cubes"></i></button>
														</div>
													</template>													
													<template slot="slot_item" slot-scope="item">
														{{ MtdFormatarZeros(item.row.item, 3) }}
													</template>													
													<template slot="id_fi" slot-scope="item">
														{{ item.row.coddig }}
													</template>
													<template slot="slot_qtditem" slot-scope="item">
														{{ MtdFormataValorDecimal(parseFloat(item.row.qtditem), 4) }}
													</template>
													<template slot="slot_qtdlevar" slot-scope="item">
														<span>{{ MtdFormataValorDecimal(parseFloat(item.row.qtditem) - parseFloat(item.row.qtdentregar), 4) }}</span>
														<i v-if="parseFloat(item.row.qtdentregar) !== parseFloat(item.row.qtditem)" @click.prevent="MtdAlterarqtdlevar(item.row)" class="fa fa-shopping-basket" style="color: #0acf97; margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
														<i v-else @click.prevent="MtdAlterarqtdlevar(item.row)" class="fa fa-shopping-basket text-black-50" style="margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
													</template>													
													<template slot="slot_unditem" slot-scope="item">
														{{ item.row.unditem }}
													</template>
													<template slot="slot_vlunitarioitem" slot-scope="item">
														{{ MtdFormataValorDecimal(parseFloat(item.row.vlunitario), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordescacres) > 0">
															<template v-if="parseInt(item.row.descacres) === 0">
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	- {{ MtdFormataValorDecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	- {{ MtdFormataValorDecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>	
															</template>														
															<template v-else>
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	+ {{ MtdFormataValorDecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	+ {{ MtdFormataValorDecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>															
															</template>
														</template>
													</template>
													<template slot="slot_vltotalitem" slot-scope="item">
														<i v-show="parseFloat(item.row.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ MtdFormataValorDecimal(parseFloat(item.row.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
														<strong style="color: #6c757d;">
															{{ MtdFormataValorDecimal(parseFloat(item.row.vltotal), 2) }}
														</strong>
													</template>
													<template slot="estoqueslst" slot-scope="item">
														<div class="dv-lst-precos-produto">
															<ul class="list-group">
																<li v-for="(estoque, indexf) in item.row.estoques" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" v-bind:class="indexf%2 == 0 ? 'bkg-smoke' : ''" style="padding: 2px;">
																	<span class="lbltabelalstpro">{{estoque.descricao}}</span>
																	<span class="lbltabelalstpro font-weight-bolder">{{  estoque.qtddisponivel  }}</span>
																</li>
															</ul>                              
														</div> 
													</template>													
												</vue-bootstrap4-table>
											</div>	
											<div class="col-md-12">
												<ul class="list-group">
													<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
														<span style="color: #666666; font-weight: bold;">Itens: <span style="font-weight: normal;">{{MtdFormatarZeros(lstitens.length, 3)}}</span></span>
														<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{MtdFormataValorDecimal(parseFloat(vtotalprodutos), 2)}}</span>
													</li>
												</ul>
											</div>									
										</div>
                                    </div>
									<div id="dvservicos" class="container-fluid tab-pane">
										<div v-show="parseInt(opcrud) < 3" class="row">
											<div  class="col-sm-12 col-md-7 col-lg-7">
												<span class="lblselect2">Serviço:</span>
												<select id="cbservico" data-placeholder="Selecione um serviço" v-model="vidservicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-5 col-lg-5">
												<span class="lblselect2">Profissional:</span>
												<select id="cbprofissional" data-placeholder="Selecione um Profissional" v-model="vidprofissionaledicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edqtdservedicao">Qtd:</label>
												<input type="number" class="form-control form-control-sm" id="edqtdservedicao" v-model="vqtdservicoedicao" v-bind="calculatotalserv" v-bind:disabled="ativadesativa" min="1" maxlength="11"/>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="cbtipodescontoservicoedicao">Tp. Descto.:</label>
												<select class="form-control form-control-sm" id="cbtipodescontoservicoedicao" v-model="vtipodescontoservicoedicao" v-bind:disabled="ativadesativa" v-bind="calculatotalserv">
													<option value="0">Percentual</option>
													<option value="1" >Valor</option>
												</select>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvalordescontoservicoedicao">{{ vtitdescserv }}</label>
												<money type="text" class="form-control form-control-sm" id="edvalordescontoservicoedicao" v-model="vvalordescontoservicoedicao" v-bind="[calculatotalserv, money]" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvlservicoedicao">Valor Unitário:</label>
												<money type="text" class="form-control form-control-sm" id="edvlservicoedicao" v-model="vvlservicoedicao" v-bind="money" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2">
												<label for="edvltotalservicoedicao">Total:</label>
												<money type="text" class="form-control form-control-sm" id="edvltotalservicoedicao" v-model="vvltotalservicoedicao" v-bind="[calculatotalserv, money]" readonly style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="MtdAdicionarServico()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12" style="margin-top: 10px;">
												<vue-bootstrap4-table
														:rows="lstservicos"
														:columns="columnss"
														:config="config"
														:classes="classes">
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem dados para visualização</div>
													</template>
													<template slot="id_f" slot-scope="item">
														{{ item.row.idservico }}
													</template>
													<template slot="slot_vlunitarioservico" slot-scope="item">
														{{ MtdFormataValorDecimal(parseFloat(item.row.vlservico), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordesconto) > 0">
															<template v-if="parseInt(item.row.tipodesconto) === 0">
																{{ MtdFormataValorDecimal(parseFloat(item.row.valordesconto), 2) }} (%)
															</template>
															<template v-else>
																{{ MtdFormataValorDecimal(parseFloat(item.row.valordesconto), 2) }} ($)
															</template>																												
														</template>
													</template>
													<template slot="slot_qtditemserv" slot-scope="item">
														{{ item.row.qtdservico }}
													</template>
													<template slot="slot_vltotalservico" slot-scope="item">
														<strong style="color: #6c757d;">{{ MtdFormataValorDecimal(parseFloat(item.row.vltotal), 2) }}</strong>
													</template>																																					
													<template slot="opcoes" slot-scope="item">
														<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="MtdExcluirServico(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
													</template>
												</vue-bootstrap4-table>
											</div>
											<div class="col-md-12">
												<ul class="list-group">
													<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
														<span style="color: #666666; font-weight: bold;">Serviços: <span style="font-weight: normal;">{{MtdFormatarZeros(lstservicos.length, 3)}}</span></span>
														<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{MtdFormataValorDecimal(parseFloat(vtotalservicos), 2)}}</span>
													</li>
												</ul>
											</div>											
										</div>
									</div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
											<div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-8 col-lg-10">
												<span class="lblselect2">Informação complementar:</span>
												<select id="cbinfcpl" data-placeholder="Selecione uma opção" v-model="vidinfcpl"
														v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div v-show="parseInt(opcrud) < 3" class="col-md-2">
												<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="MtdAdicionarInfCpl()" style="margin-top: 22px;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
											<div class="col-sm-12" style="margin-top: 15px;">
												<textarea class="form-control center" rows="5" id="tcfwef" v-model="vobservacoes" v-bind:disabled="ativadesativa" maxlength="5000"></textarea>
											</div>			
										</div>
									</div>                                                                            
                                </div> 
                            </div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-4" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Itens</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 100px; background-color: #4250f2;">{{ vqtditens }}</span>
									</li>
								</ul>
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-4" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Quantitativo</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{vquantitativo}}</span>
									</li>
								</ul>
							</div>																					
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Total Geral</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #5A956A;">{{MtdFormataValorDecimal(parseFloat(vtotalgeral), 2)}}</span>
									</li>
								</ul>
							</div>                                                                   
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="MtdGravar()"
										v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="MtdGravar()"
										v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="MtdGravar()"
										v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="MtdCancelarEdicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
				<!-- Modal para seleção do plano de pagamento -->
				<div class="modal fade" id="mdselecionarplano">
					<div class="modal-dialog modal-sm modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<div class="list-group">								
										<a v-for="(plano, index) in lstplanos" href="#" v-bind:class="parseInt(plano.id) === parseInt(vidplano) ? 'active': ''" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="MtdDefinePlano(plano)">{{ MtdFormatarZeros(plano.id, 2) }} - {{ plano.descricao }}</a>
									</div>							
								</div>
							</div>
						</div>
						<div class="modal-footer" style="padding: 5px;">
							<div class="container-fluid">
								<div class="row">
									<div class="col-md-12 text-center">
										<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
									</div>
								</div>					
							</div>
						</div>				        
					</div>
					</div>
				</div>
                <!-- Modal de edição do ítem do pedido -->
                <div class="modal fade" id="mdedicaoitem" tabindex="-1">
                    <div class="modal-dialog modal-xl modal-dialog-centered">
                        <div class="modal-content">     
                            <div class="modal-header">
                                <h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
                                <h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração) - {{ MtdFormatarZeros(vitemalteracao, 3) }}</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <!-- CP PRODUTO EDIÇÃO -->
                                    <div class="col-sm-12 col-md-4 col-lg-3">
                                        <label for="edidprodutoedicao">*Produto:</label>
                                        <div class="input-group" style="z-index: 1;">
                                            <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddigedicao" maxlength="20" @change="MtdLocalizarProduto(vcoddigedicao)" v-on:keyup.13="MtdLocalizarProduto(vcoddigedicao)" style="text-transform: uppercase;">
                                            <div class="input-group-append">
                                                <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="MtdConsultarProduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-8 col-lg-7">
                                        <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                        <div class="input-group" style="z-index: 1;">
                                            <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" v-bind:disabled="vedicaodescpro" @change="MtdDesabilitaEdicaoDescPro()">
                                            <div class="input-group-append">
                                                <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="MtdHabilitaEdicaoDescPro()" title="Alterar descrição"><i class="fa fa-edit" style="padding-top: 3px;"></i></a>
                                            </div>
                                        </div>									
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                        <label for="edundprodutoedicao">Und:</label>
                                        <input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-3">
                                        <label for="edqtditemedicao">*Quantidade:</label>
										<div class="input-group" style="z-index: 1;">
											<div class="input-group-append">
												<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="MtdQuantidade(2)"><i class="fa fa-minus"></i></a>
											</div>									
											<money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
											<div class="input-group-append">
												<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="MtdQuantidade(1)"><i class="fa fa-plus"></i></a>
											</div>									
										</div>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-3">
                                        <label for="cbmanipulavaledicao">Manipular valor:</label>
                                        <select class="form-control form-control-sm" id="cbmanipulavaledicao" v-model="vmanipulavaledicao" v-bind:disabled="pmanipularvaloritem">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>							
                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                        <label for="cbdescacresedicao">Atribuir:</label>
                                        <select class="form-control form-control-sm" id="cbdescacresedicao" v-model="vdescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
                                            <option value="0">Desconto</option>
                                            <option value="1">Acréscimo</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                        <label for="cbtipodescacresedicao">Tipo:</label>
                                        <select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="vtipodescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
                                            <option value="0">Percentual</option>
                                            <option value="1">Valor</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-2">								
                                        <label for="edvaldescacresedicao">{{ vtitdesc }}</label>
                                        <div class="input-group" style="z-index: 1;">
                                            <money type="text" class="form-control form-control-sm" id="edvaldescacresedicao" v-model="vvalordescacresedicao" v-bind="[calculatotalitem, money]"  data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            <div class="input-group-append" style="height: 31px;">
                                                <span v-if="parseInt(vtipodescacresedicao) === 0" class="input-group-text font-weight-bold">%</span>	
                                                <span v-else class="input-group-text font-weight-bold">$</span>	
                                            </div>									
                                        </div>
                                    </div>
                                    <div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
                                        <label for="edvlunitarioedicao">*Valor Unitário:</label>
                                        <money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vvlunitarioedicao" v-bind:disabled="manipulaval" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                    </div>
                                    <div v-show="parseFloat(vvltotalimpostoitemedicao) > 0" class="col-sm-12 col-md-3 col-lg-2">
                                        <label for="edimpostoitemedicao">Imposto(R$):</label>
                                        <input type="text" class="form-control form-control-sm text-right text-warning" id="edimpostoitemedicao" v-bind:value="MtdFormataValorDecimal(parseFloat(vvltotalimpostoitemedicao), 2)" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>								
                                    </div>							
                                    <div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
                                        <label for="edvltotaledicao">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotaledicao" v-model="vvltotaledicao" v-bind="[calculatotalitem, money]" readonly style="font-weight: bold; text-align:right;"></money>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-3">
                                        <span class="lblselect2">*Estoque:</span>
                                        <select id="cbestoqueedicao" data-placeholder="Selecione um estoque" v-model="videstoqueedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>																																																		
                                    <div class="col-sm-12 col-md-2 col-lg-3">
                                        <span class="lblselect2">Solicitante:</span>
                                        <select id="cbtecnicosolicitaedicao" data-placeholder="Selecione o técnico/solicitante" v-model="vidtecnicosolicitaedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>																
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label for="txtinfadprod">Informações adicionais do item:</label>
                                        <textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprod" maxlength="500"></textarea>
                                    </div>
                                    <div class="col-md-12 text-right">
                                        <span class="text-black-50" style="font-size: 12px; font-weight: 600;">{{ vinfadprod.length }} caracteres de 500</span>
                                    </div>						
                                </div>
                            </div>        
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary btn-sm" @click.prevent="MtdGravarItem()" id="btnsalvaritem"><i class="fa fa-check"></i> Confirmar</button>
                                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                            </div>        
                        </div>
                    </div>
                </div>
				<!-- Modal para aplicação do desconto nos itens -->
				<div class="modal fade" id="mdaplicardesconto">
					<div class="modal-dialog modal-sm modal-dialog-centered">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">Aplicar desconto</h4>
								<button type="button" class="close" data-dismiss="modal">&times;</button>
							</div>
							<div class="modal-body">
								<div class="row">							
									<div class="col-md-12">
										<label for="edtotalitenssemdesconto">Total dos itens SEM desconto:</label>
										<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="vtotalsemdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
									</div>							
									<div class="col-md-12">
										<label for="cbtipodesctotal">Tipo:</label>
										<select class="form-control form-control-sm" id="cbtipodesctotal" v-model="vtipodesctotal" style="font-size: 18px; font-weight: bold;">
											<option value="0">Percentual</option>
											<option value="1">Valor</option>
										</select>
									</div>
									<div class="col-md-12">
										<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Percentual do desconto</label>
										<label v-else for="edfatordescontototal">Valor do desconto</label>
										<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vfatordescontototal" v-bind="[calculadescontototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
									</div>
									<div class="col-md-12">
										<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Desconto(R$)</label>
										<label v-else for="edfatordescontototal">Desconto(%)</label>
										<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vresdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
									</div>														
									<div class="col-md-12">
										<label for="edtotalitenscomdesconto">Total dos itens COM desconto:</label>
										<money type="text" class="form-control form-control-sm" id="edtotalitenscomdesconto" v-model="vtotalcomdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
									</div>							
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-primary btn-sm" id="btnconfirmadesconto" @click.prevent="MtdConfirmaAplicacaoDesconto()"><i class="fa fa-check"></i> Aplicar</button>
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
							</div>        
						</div>
					</div>
				</div>
				<div class="modal fade" id="mdmenupedido">
					<div class="modal-dialog modal-sm modal-dialog-centered">
						<div class="modal-content">
							<div class="modal-body">
								<div class="row">
									<div class="col-md-12">
										<ul class="list-group" style="cursor: pointer;">
											<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(pedidomenu.idagendamento, 8) }}</li>
											<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdAlterar(pedidomenu)"><i class="fa fa-edit"></i> ALTERAR</li>
											<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdExcluir(pedidomenu)"><i class="fa fa-trash"></i> EXCLUIR</li>
											<li v-if="parseInt(pedidomenu.liberarpdv) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdRotinaPdv(pedidomenu.idagendamento, pedidomenu)"><i class="fa fa-unlock"></i> LIBERAR PDV</li>
											<li v-else class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdRotinaPdv(pedidomenu.idagendamento, pedidomenu)"><i class="fa fa-lock"></i> BLOQUEAR PDV</li>
											<li v-show="parseInt(pedidomenu.stpedido) === 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdRemarcarAgendamento(pedidomenu)"><i class="fa fa-calendar"></i> REMARCAR AGENDAMENTO</li>
											<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="MtdCancelarAgendamento(pedidomenu)"><i class="fa fa-times"></i> CANCELAR AGENDAMENTO</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="modal-footer" style="padding: 5px;">
								<div class="container-fluid">
									<div class="row">
										<div class="col-md-12 text-center">
											<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
										</div>
									</div>					
								</div>
							</div>				        
						</div>
					</div>
				</div>
				<!-- Modal remarcar agendamentp -->
				<div class="modal fade" id="mdremarcaragendamento">
					<div class="modal-dialog modal-sm modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header">
							<h4 class="modal-title"><i class="fa fa-edit"></i> Remarcar Agendamento(Alteração)</h4>
							<button type="button" class="close" data-dismiss="modal">&times;</button>
						</div>
						<div class="modal-body">
							<div class="row">
								<div class="col-sm-12 col-md-3 col-lg-10">
									<label for="eddtagendamento">Dt. Agendamento:</label>
									<div class="input-group">
										<date-picker id="eddtagendamento" v-model="vdtagendamentopet" :config="options"
											class="form-control form-control-sm"></date-picker>
										<div class="input-group-append">
											<span class="input-group-text"><i class="fa fa-calendar"></i></span>
										</div>										
									</div>
								</div>
								<div class="col-sm-12 col-md-2 col-lg-10">
									<label for="edhrini">Hr. Agendamento:</label>
									<input type="text" v-model="phrag" 
										class="form-control form-control-sm" id="edhrini" 
										v-mask="'##:##'" 
										@blur="ValidarHorario">
									<div v-if="erroHorario" class="text-danger">
										Horário inválido! Insira um horário entre 00:00 e 23:59.
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer" style="padding: 5px;">
							<div class="container-fluid">
								<div class="row">
									<div class="col-md-6">
										<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
									</div>
									<div class="col-md-6">
										<button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click.prevent="MtdConfirmaNovoAgendamento(vidagendamentopet)" style="width: 100px;"><i class="fa fa-check"></i> Confirmar</button>
									</div>
								</div>					
							</div>
						</div>				        
					</div>
					</div>
				</div>
            </div>
        </div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
	import InformacoesCliente from '../components/cmpinformacoescliente.vue'
	import ConsultarClientes from '../components/cmpconsultarclientes.vue'
	import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'

    export default {
        name: 'cadagendamentospet',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
			'informacoescliente'	: InformacoesCliente,
            'consultaclientes'  	: ConsultarClientes,
			'consultaprodutos'  	: ConsultarProdutos,
        },
        data: function() {
            return {
                utodasfiliais         : this.$store.state.usuario.todasfiliais,
				//variaveis da consulta de produtos

				pfiltroperiodo      : 1,
				pfiltropor          : 0,
				pdtini              : util.DataAtual(true),
				pdtfim              : util.DataAtual(true),
				pqtdregistros       : 10,
				pagina_atual        : 1,
				pqtd_total_registros: 0,

				vidagendamentopet   : '',
				vidfilialpet        : null,
				vdtemissaopet       : util.DataAtual(true),
				vdtagendamentopet   : util.DataAtual(true),
				vidclientepet       : '',
				vnomeclientepet     : '',
				vimagempet          : '',
				vpet                : null,
				vagendamentopet     : 0,
				vpagamentopet       : 0,
				vbuscapet           : 0,
				ventregapet         : false,
				vdtentregapet       : util.DataAtual(true, true),
				phrag               : util.HoraAtual(false, true),
				erroHorario         : false,
				isLoadingimgpet     : true,

				//variáveis para o cancelamento
				agendamentocancelar	: [],


				ptotalcusto			: 0,

				//Variavel listagem pet
				pidagendamentopet   : '',
				pidfilialpet        : null,
				pidclientepet       : null,
				pchippet            : '',
				pstagendamentopet   : 0,
				pstpagamentopet     : 0,

				//Variável de edição dos itens do pedido
				vvltotal_old_edicao : 0,//somente para a alteração
				alteraentra         : false,
				vedicaodescpro      : true,
				vitem               : 0,
				vitemalteracao      : 0,
				vtitdesc            : '%',
				vopitem             : 0,                            
				vidprodutoedicao    : '',
				vcoddigedicao       : '',
				vdescricaoprodutoedicao: '',
				vundprodutoedicao   : '',
				vqtditemedicao      : 1,
				vvltabelaitemedicao : 0,
				vvlunitarioedicao   : 0,
				vprvendaminimo      : 0,
				vdescacresedicao    : 0,
				vtipodescacresedicao: 0,
				vvalordescacresedicao: 0,
				vmanipulavaledicao  : 0,
				vvltotalimpostoitemedicao: 0,
				videstoqueedicao    : null,
				vfracionadoedicao   : 0,
				vinfadprod          : '',
				vidtecnicosolicitaedicao: null,    
				vdadosclasseitem    : [],
				vldescmostrar       : 0,

				//variáveis do crud
				opcrud              :  0,
				vid                 : '',
				valertarcliente     : false,
				vdtentrega          : util.DataAtual(true), 
				vtelefonepet        : '',               
				vresponsavelpet     : '',
				vconteudoalerta     : '',
				lstitens            : [],
				vtotalprodutos      : 0,

				/////////////////////
				vshowprtabela       : true,
				tipopropesquisa     : '0, 2',
				lstpedidos          : [],
				pidplano            : null,
				pidvendedor         : null,
				pidrota             : null,
				pqtd_paginas        : 1,

				pidforma            : null,    
				vermelho            : false,   

				//id do produto para visualização
				idprodutoestoque    : 0,
				descproestoque      : '',

				vnomecliente        : '',
				vidvendedor         : null,
				vidinfcpl           : null,
				vinfcpl             : '',

				vidplano            : null,
				vtipoplano          : 0,
				vdescplano          : '',
				vidtabela           : null,//carrega a tabela vinculada ao plano de pagamento
				vpercentrada        : 0,
				vpermitedesconto    : 0,

				vvltotaledicao		: 0,
				vtotalservicos      : 0,
				vobservacoes        : '',
				vtotalgeral         : 0,
				vqtditens           : 0,
				vquantitativo       : 0,
				vdtfatura           : '',
				vreservar           : false,
				ventregaexterna     : false,
				vpathimagens        : '',
				lstservicos         : [],
				lstplanos           : [],
				lstagendamentos     : [],
				vtotfrete           : 0,
				ativaedicaofrete    : false,                


				vmostraestoque      : false,

				//pega o path do diretorio padrão das imagens
				pathimgview         : this.$store.state.configpaths.pathimagens,                

				//variáveis de edição dos serviços
				vprecoservicoedicao    		: [],
				vtitdescserv           		: 'Descto.(%)',                
				vidservicoedicao       		: null,
				vidprofissionaledicao       : null,
				vqtdservicoedicao      		: 1,
				vvlservicoedicao       		: 0,
				vtipodescontoservicoedicao	: 0,
				vvalordescontoservicoedicao	: 0,
				vvltotalservicoedicao  		: 0,

				//variável para habilitação dos campos
				ativadesativa             	: true,

				pedidomenu                	: [], //para geração do menu do pedido no modal

				//variáveis aplicação do desconto no total dos itens
				vtotalsemdesconto   : 0,
				vtotalcomdesconto   : 0,
				vtipodesctotal      : 0,    
				vfatordescontototal : 0,
				vresdesconto        : 0,    

				//variaveis do faturamento
				pedidofaturar       : [],
				vidformapagamento   : null,
				vvlforma            : 0,
				vtipoforma          : 0,
				vespecieforma       : 0,
				vabatecredito       : 0,

				idproduto          	: null,

				cliente             : [],
				usuario             : [],

				//variaveis de perfil
				pmanipularvaloritem 	: false,
				pdefinirestoque			: false,
				palterardatafatura		: false,
				palterarvendedor		: false,

				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       :  false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'AGENDAMENTO DE PETS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columnsi: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        column_classes: "def-col-opcoes",
						sort: false,
						slot_name: "opcoesi"
					},
                    {
                        label: "Ítem",
						name: "item",
						slot_name: "slot_item",
						sort: true,
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
						initial_sort_order: 'asc',
						column_classes: "def-col-item",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },					
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_fi",
						column_classes: "def-col-coddig",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},				
                    {
                        label: "Und.",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
						column_classes: "def-col-unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Vl. Unitário",
                        name: "vlunitario",
                        sort: true,
                        slot_name: "slot_vlunitarioitem",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Desc/Acres",
                        name: "valordescacres",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Levar",
                        name: "qtdlevar",
                        sort: true,
                        slot_name: "slot_qtdlevar",
						column_classes: "def-col-qtdlevar",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left",						
						visibility:	false
					},					
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalitem",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Solicitante",
                        name: "nometecnicosolicita",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},	
					{
						visibility : false,
                        label: 'Estoque',
                    
						sort: false,
						slot_name: "estoqueslst",
						row_classes: "def-col-estoques-cmp",
					},
				],
				columnss: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "idservico",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descservico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Técnico",
                        name: "nometecnico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vl. Unitário",
                        name: "vlservico",
                        sort: true,
                        slot_name: "slot_vlunitarioservico",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Descto.",
                        name: "valordesconto",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtdservico",
                        sort: true,
                        slot_name: "slot_qtditemserv",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalservico",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
				],
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Agendamento",
                        name: "idagendamento",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "id_f",
                        row_classes: "def-col-nragendamento",
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pet",
                        name: "nomepet",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Responsável",
                        name: "responsavel",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt.Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt.Agendamento",
                        name: "dtagendamento",
                        sort: true,
                        slot_name: "slot_dtagendamento",
                        row_classes: "def-col-dtagendamento",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt.Entrega",
                        name: "dtentrega",
                        sort: true,
                        slot_name: "slot_dtentrega",
                        row_classes: "def-col-dtentrega",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
						label: "St. Agendamento",
                        name: "stagendamento",
                        sort: true,
                        slot_name: "slot_stagendamento",
                        row_classes: "def-col-stagendamento",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },
					{
						label: "St. Pagamento",
						name: "stpagamento",
						sort: true,
						slot_name: "slot_stpagamento",
						row_classes: "def-col-stpagamento",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left"
					},
					{
						label: "Total",
						name: "totalgeral",
						sort: true,
						slot_name: "slot_totalgeral",
						row_classes: "def-col-total",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left"
					},
                ],                
                config: {
                    pagination: false,
                    // checkbox_rows: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
            }
        },
        methods:{
			ValidarHorario() {
				// Verifica se o horário inserido é válido
				let partes = this.phrag.split(':');
				let horas = parseInt(partes[0], 10);
				let minutos = parseInt(partes[1], 10);

				// Define a condição para um horário válido
				if (horas >= 0 && horas <= 23 && minutos >= 0 && minutos <= 59) {
					this.erroHorario = false;
				} else {
					this.erroHorario = true;
				}
			},
			MtdAdicionarInfCpl(){             
				let vself       = this;
				if (vself.vidinfcpl !== null){    
					let loader      = vself.$loading.show();
					let filtro      = ' and id='+vself.vidinfcpl;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadinformacoescomplementares.php');
					retorno.then(function (response) {
						loader.hide();   
						if((vself.vobservacoes === '' )||(vself.vobservacoes === undefined)){
							vself.vobservacoes = response.data[0].conteudo; 
						}else{
							vself.vobservacoes = vself.vobservacoes +'\n'+ response.data[0].conteudo;
						}                     
						// vself.vinfcpl = vself.vinfcpl === '' ? response.data[0].conteudo : vself.vinfcpl +'\n'+ response.data[0].conteudo;
						$('#cbinfcpl').val(null).trigger('change');
					}).catch(function (response) {
							loader.hide();
					});
				}             
			},
			MtdLocalizarCliente(idcliente){		
				if (idcliente !== '' && idcliente !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and c.ativo=0 and c.id='+idcliente},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let cliente = response.data[0];				
							vself.vidclientepet  			= cliente.id;
							vself.vnomeclientepet 			= cliente.nome;
							vself.valertarcliente			= parseInt(cliente.alertarcliente) === 0 ? false : true;
							vself.vidplano 					= null;
							vself.vtipoplano				= 0;
							vself.vdescplano				= '';
							vself.vidtabela					= null;
							vself.vpet						= null;
							$("#cbpet").val(null).trigger('change');
							
							vself.MtdLocalizarPlanos();
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidclientepet 	= '';
							vself.vnomeclientepet 	= '';
							vself.valertarcliente 	= false;
							vself.vidplano 			= null;
							vself.vtipoplano		= 0;
							vself.vdescplano		= '';
							vself.vpercentrada		= 0;
							vself.vpermitedesconto 	= 0;
							vself.vidtabela			= null;	
							vself.vpet				= null;
							$("#cbpet").val(null).trigger('change');
							vself.lstplanos			= [];
							$('#edcliente').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.vidclientepet 	    = '';
					this.vnomeclientepet 	= '';
					this.valertarcliente    = false;
					this.vidtabela		    = null;
					this.vidplano 			= null;
					this.vpet 				= null;
					$("#cbpet").val(null).trigger('change');
					this.vtipoplano			= 0;
					this.vdescplano			= '';
					this.vpercentrada       = 0;					
					this.vpermitedesconto   = 0;
					this.lstplanos			= [];
				}
            },
			MtdConsultarCliente(){
				if (parseInt(this.opcrud) < 3){
					this.vidclientepet      = '';
					this.vnomeclientepet 	= '';
					this.vconteudoalerta    = '';
					this.lstplanos    = [];
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);
					let payloadx = {
						idcliente    : null			
					};
					this.$store.commit('CLIENTE_RETORNO_CHANGE',payloadx);                
				}
			},
            MtdLimparEdicaoItem(){			
				this.vedicaodescpro				= true;
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vvlunitarioedicao			= 0;

				this.vqtdminimodescedicao       = 0,
				this.vvldescontoqtdmin          = 0,

				this.vprvendaminimo				= 0;
				this.vldescpromocionalitemedicao= 0;
				this.vdescacresedicao			= 0;
				this.vtipodescacresedicao		= 0;
				this.vvalordescacresedicao		= 0;
				this.vmanipulavaledicao			= 0;
				this.vvltotalimpostoitemedicao  = 0;
				this.vvltotaledicao				= 0;
				this.vfracionadoedicao			= 0;
				this.vinfadprod					= '';
				this.vdadosclasseitem			= [];
				this.vldescmostrar				= 0;

				this.vidtecnicosolicitaedicao	= null;
				$("#cbtecnicosolicitaedicao").val('').trigger('change');

				//pega o estoque padrão da filial selecionada
				this.videstoqueedicao			= this.$store.state.filialpadrao.idestoque;
                var defestoque  				= new Option(this.$store.state.filialpadrao.descestoque, this.videstoqueedicao, true, true);
				$('#cbestoqueedicao').append(defestoque).trigger('change');
				   
			},
			MtdAdicionarItem(){
				if (this.vidfilialpet === null){
					this.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilialpet').focus();
					return;
				}
				if (this.vidclientepet === ''){
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (this.vidplano === null){
					this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}				
				this.vopitem					= 1;
				this.MtdLimparEdicaoItem();
				$('#mdedicaoitem').modal('show');
			},
			MtdSelect2_Def(){
				let vself = this;
				$('#mdedicaoitem').on('show.bs.modal', function (e) {
				});			
				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidprodutoedicao').focus();
					}else{
						$('#edqtditemedicao').focus();
					}
				});
				$('#mdaplicardesconto').on('shown.bs.modal', function (e) {
					$('#cbtipodesctotal').focus();
				});
				$('#mdmenupedido').on('show.bs.modal', function (e) {
				});	
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';			

				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				}); 
				$("#cbestoqueedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueedicao = $("#cbestoqueedicao").val();
				});
				$("#cbprofissional").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidprofissionaledicao = $("#cbprofissional").val();
				});				
				$("#cbtecnicosolicitaedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicosolicitaedicao = $("#cbtecnicosolicitaedicao").val();
				});				
				$("#cbfilialpet").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialpet = $("#cbfilialpet").val();
					vself.MtdLocalizarPlanos();
					vself.MtdSelect2ServicoDef();
				});		
				$("#cbinfcpl").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbinformacoescomplementares',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
									results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidinfcpl = $("#cbinfcpl").val();
				});
				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilialpet = $("#cbfilialpesq").val();
					vself.MtdLimparListagem();
				});
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidclientepet = $("#cbclientepesq").val();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidvendedor = $("#cbvendedorpesq").val();
				});
				$("#cbplanopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbplanospagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidplano = $("#cbplanopesq").val();
				});
				$("#cbrotapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidrota = $("#cbrotapesq").val();
				});
				$("#cbformapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidforma     = $("#cbformapesq").val();
				});				
				//campos para faturamento
				$('#mdalterartitulo').on('shown.bs.modal', function (e) {
					$('#eddtventit').focus();
				});				
				$("#cbformapagamento").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformapagamento     = $("#cbformapagamento").val();
                    if (vself.vidformapagamento != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and f.id='+vself.vidformapagamento},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                        retorno.then(function (response) {
                            vself.vtipoforma = parseFloat(response.data[0].tipo); 
							vself.vespecieforma = parseFloat(response.data[0].especie);
							vself.vabatecredito = parseInt(response.data[0].abatecredito); 
							vself.vnrvendaforma = '';					
							vself.vidperfilfluxoforma   = 0;                
							vself.vdescperfilfluxoforma = ''; 																			
                            loader.hide();

							if (parseInt(vself.vabatecredito) === 1){//localiza o crédito quando houver
								let loader      = vself.$loading.show();
								let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.pedidofaturar.idcliente;
								let parametros  = [
									{parametro: 'op',           	valor : 'listagem'},
									{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
									{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'filtro',       	valor : filtro},
									{parametro: 'limit',        	valor : 1},
									{parametro: 'offset',       	valor : 0},
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
								retorno.then(function (response) {
									loader.hide();
									if (response.data.agendamentos.length > 0){
										let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.pedidofaturar.fatorcreditoutilizar) * parseFloat(vself.pedidofaturar.totalgeral) / 100, 2, 'round');				
										let vlcreditodisp = parseFloat(response.data.agendamentos[0].vlcredito) - parseFloat(response.data.agendamentos[0].vlcreditoutilizado);
										if (parseInt(parseFloat(vlcreditodisp) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
											vself.vvlforma = vllimitecreditoabater;
										}else{
											vself.vvlforma = vlcreditodisp;
										}
										//vself.vvlforma = util.arredondaValores(parseFloat(response.data.agendamentos[0].vlcredito) - parseFloat(response.data.agendamentos[0].vlcreditoutilizado) * parseFloat(response.data.agendamentos[0].fatorcreditoutilizar) / 100, 2, 'round');
										vself.vnrvendaforma = response.data.agendamentos[0].id;
									}
								}).catch(function (response) {
									console.log(response);
									vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
									$('#cbformapagamento').focus();
									loader.hide();
								});
							}
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vtipoforma = 0;
						vself.vespecieforma = 0;
						vself.vabatecredito = 0;
						vself.vnrvendaforma = '';
                        vself.vidperfilfluxoforma   = 0;                
                        vself.vdescperfilfluxoforma = ''; 												
                    }										
				});

				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.taidtipocobranca != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.taidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.tatipocobranca = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.tatipocobranca = 0;
                    }					
				});

				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidbanco = $("#cbbanco").val();
				});

				$("#cbsituacaocheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidsituacaocheque = $("#cbsituacaocheque").val();
				});

				//cancelamento
				$('#mdcancelarpedido').on('shown.bs.modal', function (e) {
					$('#txtmotivocancelamento').focus();
				});
				
				$('#mdalteracaoqtdlevar').on('shown.bs.modal', function (e) {
					$('#edqtdlevar').focus();
				});	
				
				$('#mddefinirqtdentregue').on('shown.bs.modal', function (e) {
					$('#edqtdlevarentrega').focus();
				});	
				
                $("#cbperfilfluxofinal").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aidperfilfluxo = $("#cbperfilfluxofinal").val();
                });

				$("#mdlalterarperfilfluxofinal").on('show.bs.modal', function(){
					$('#cbperfilfluxofinal').select2('open');
				});	
				
				//itens cortados
				$("#cblcvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidvendedor = $("#cblcvendedor").val();
				});	
				$("#cblccliente").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidcliente = $("#cblccliente").val();
				});	
				$("#cblcproduto").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbprodutos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidproduto = $("#cblcproduto").val();
				});	
				$("#cblcsubgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsubgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidsubgrupo = $("#cblcsubgrupo").val();
				});	
				$("#cblcgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidgrupo = $("#cblcgrupo").val();
				});	
				$("#cblcmarca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidmarca = $("#cblcmarca").val();
				});	
				
				//crédito avulso
				$("#cbfilialca").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialca = $("#cbfilialca").val();
				});

				$("#cbclienteca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidclienteca = $("#cbclienteca").val();
				});
			},
			MtdAlterarItem(item){
				if (!util.opcaousuario('020Z.050Z.020Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}
				var vself       = this;
				if (vself.vidfilialpet === null){
					vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilialpet').focus();
					return;
				}
				if (vself.vidclientepet === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (vself.vidplano === null){
					vself.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}								
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : item.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
						let produto = response.data[0];	

						vself.vvltotal_old_edicao		= item.vltotal;//variável para estornar o valor anterior
						//vself.vtotalimpostos_old_edicao = item.vltotalimposto;

						vself.vdadosclasseitem			= vself.MtdClasseItem(produto.classes);

						vself.alteraentra  				= true;																			
						vself.vopitem					= 2;
						vself.vitemalteracao			= item.item;
						vself.vedicaodescpro			= true;
						vself.vidprodutoedicao    		= item.idproduto;
						vself.vcoddigedicao				= item.coddig;
						vself.vdescricaoprodutoedicao 	= item.descproduto;
						vself.vundprodutoedicao			= item.unditem;
						vself.vprvendaminimo			= item.prvendaminimo;
						vself.vqtditemedicao			= parseFloat(item.qtditem);
						vself.vvltabelaitemedicao		= parseFloat(util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela));						
						vself.vvlunitarioedicao			= parseFloat(item.vlunitario);
						vself.vprvendaminimo			= parseFloat(item.prvendaminimo);						

						//carrega o desconto promocional
						let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);
						vself.vldescpromocionalitemedicao 	= produto.tabelas[it].vldescpromocional;						
						///////////////////////////////

						vself.vdescacresedicao			= item.descacres;
						vself.vtipodescacresedicao		= item.tipodescacres;
						vself.vvalordescacresedicao		= parseFloat(item.valordescacres);
						vself.vmanipulavaledicao		= item.manipulaval;
						vself.vvltotaledicao			= parseFloat(item.vltotal);
						vself.vvltotalimpostoitemedicao = parseFloat(item.vltotalimposto);
						vself.vfracionadoedicao			= produto.fracionado;
						vself.vinfadprod				= item.infadprod;

						vself.vqtdminimodescedicao      = vself.MtdPegaDadosDescTabela(1, produto.tabelas, vself.vidtabela)
						vself.vvldescontoqtdmin         = vself.MtdPegaDadosDescTabela(2, produto.tabelas, vself.vidtabela)						

						if (parseInt(item.idtecnicosolicita) > 0){
							vself.vidtecnicosolicitaedicao  = item.idtecnicosolicita;
							var deftec  				    = new Option(item.nometecnicosolicita, item.idtecnicosolicita, true, true);
							$('#cbtecnicosolicitaedicao').append(deftec).trigger('change');						
						}else{
							vself.vidtecnicosolicitaedicao  = null;
							$("#cbtecnicosolicitaedicao").val('').trigger('change');
						}

						vself.videstoqueedicao			= item.idestoque;
						var defestoque  				= new Option(item.descestoque, item.idestoque, true, true);
						$('#cbestoqueedicao').append(defestoque).trigger('change');

						$('#mdedicaoitem').modal('show');				
					}else{
						vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});
			},
			MtdGravarItem(){
				let vself = this;
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}
				if (parseFloat(this.vvlunitarioedicao) <= 0){
					this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
					$('#edvlunitarioedicao').focus();
					return;
				}
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
				if (this.videstoqueedicao === null){
					this.$toastr.w('Estoque deve ser informado!', 'Atenção!');
					$('#cbestoqueedicao').focus();
					return;
				}
				// VERIFICA SE O VALOR DE DESCONTO BATE COM O VALOR DE DESCONTO DA TABELA, SE SIM, PERMITE GRAVAR,
				// SE NÃO, ENTRA NA LÓGICA DO DESCONTO -- Akira e Rodrigo
				if (parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) <= parseFloat(this.vvldescontoqtdmin) 
				&& parseInt(this.vtipodescacresedicao) === 1 && parseFloat(this.vqtditemedicao) >= parseFloat(this.vqtdminimodescedicao)){

				} else {
					let fatd = 0;
					if (parseInt(this.vdescacresedicao) === 0){					
						if (parseInt(this.vtipodescacresedicao) === 0){
							fatd = this.vvalordescacresedicao;
						}else{
							fatd = parseFloat(this.vvalordescacresedicao) / (parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao)) * 100;
						}
	
						if (parseInt(this.vtipodescacresedicao) === 0){
							if (parseFloat(this.vldescpromocionalitemedicao) > 0){
								if (parseFloat(this.fatd) > parseFloat(this.vldescpromocionalitemedicao)){
									this.$toastr.i('Desconto promocional maior que o permitido para o item!', 'Informação!');
									$('#edfatordesconto').focus();
									return;
								}	
							}else{
								if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
									this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
									$('#edvaldescacresedicao').focus();					
									return;
								}
	
								let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;
	
								if (parseFloat(fatd) > parseFloat(descto_comparar)){
									this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
									$('#cbtipodesctotal').focus();					
									return;
								}							
							}
						}else{
							if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
								this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
								$('#edvaldescacresedicao').focus();					
								return;
							}
	
							let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;
	
							if (parseFloat(fatd) > parseFloat(descto_comparar)){
								this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
								$('#cbtipodesctotal').focus();					
								return;
							}	
						}
					
						if (parseFloat(this.vprvendaminimo) > 0){
							let vldesconto = 0;
							if (parseInt(this.vtipodescacresedicao) === 0){
								vldesconto = parseFloat(this.vvalordescacresedicao) * parseFloat(this.vvlunitarioedicao) / 100;														
							}else{
								vldesconto = parseFloat(this.vqtditemedicao) > 0 ? parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) : 0;	
							}
							vldesconto		= util.arredondaValores(vldesconto, 2, 'round');					
							if ((parseFloat(this.vvlunitarioedicao) - parseFloat(vldesconto)) < parseFloat(this.vprvendaminimo)){
								this.$toastr.w('Impossível vender o item com o valor abaixo do mínimo!', 'Atenção!');
								$('#edvlunitarioedicao').focus();
								return;
							}
						}					
						
					}
					$('#btnsalvaritem').prop('disabled', true);
				}

				// Verifica se o item está sendo adicionado (vopitem = 1)
				if (parseInt(this.vopitem) === 1) {
					// Verifica se o produto já está incluído na lista de itens
					if (util.findValInArray(this.lstitens, 'idproduto', this.vidprodutoedicao)) {
						// Verifica se o usuário tem permissão para adicionar o item novamente
						if (!util.opcaousuario('020Z.010Z.075Z', this.$store.state.perfilusuario)) {
							// Exibe uma mensagem informando que o item já foi adicionado
							this.$toastr.i('Item já incluso no pedido. Favor utilizar alteração para manipular a quantidade.', 'Informação!');
							$('#btnsalvaritem').prop('disabled', false);
							return;
						} else {
							// Abre um diálogo de confirmação para adicionar o item novamente
							$.confirm({
								title: 'Confirmação!',
								content: 'O ítem já está incluso no pedido. Deseja continuar e adicioná-lo novamente?',
								icon: 'fa fa-question-circle',
								escapeKey: true,
								backgroundDismiss: false,
								escapeKey: 'nao',
								type: 'dark',
								typeAnimated: true,
								buttons: {
									sim: {
										text: '<u>S</u>im',
										keys: ['s', 'S'],
										btnClass: 'btn-blue',
										action: function () {
											// Incrementa o valor de vitem
											vself.vitem = vself.lstitens.length === 0 ? 0 : vself.lstitens[vself.lstitens.length - 1].item;
											vself.vitem++;

											// Cria um objeto temporário para o item a ser adicionado
											let itemtmp = {
												idproduto: vself.vidprodutoedicao,
												descproduto: vself.vdescricaoprodutoedicao,
												coddig: vself.vcoddigedicao,
												item: vself.vitem,
												qtditem: parseFloat(vself.vqtditemedicao),
												unditem: vself.vundprodutoedicao,
												vlunitario: parseFloat(vself.vvlunitarioedicao),
												prvendaminimo: parseFloat(vself.vprvendaminimo),
												descacres: vself.vdescacresedicao,
												tipodescacres: vself.vtipodescacresedicao,
												valordescacres: parseFloat(vself.vvalordescacresedicao),
												manipulaval: vself.vmanipulavaledicao,
												vltotal: parseFloat(vself.vvltotaledicao),
												vltotalimposto: parseFloat(vself.vvltotalimpostoitemedicao),
												idestoque: vself.videstoqueedicao,
												descestoque: $('#cbestoqueedicao').select2('data')[0]['text'],
												infadprod: vself.vinfadprod,
												qtdentregar: parseFloat(vself.vqtditemedicao),
												idtecnicosolicita: vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
												nometecnicosolicita: vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']
											};

											// Atualiza os totais e adiciona o item à lista
											vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);
											vself.lstitens.push(itemtmp);
											vself.vtotalgeral = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos) + parseFloat(vself.vtotfrete);
											vself.vquantitativo = parseFloat(vself.vquantitativo) + parseFloat(vself.vqtditemedicao);
											vself.vqtditens = vself.lstitens.length;

											// Limpa os campos de edição e foca no próximo item
											vself.MtdLimparEdicaoItem();
											$('#edidprodutoedicao').focus();
											setTimeout(() => {
												$('#btnsalvaritem').prop('disabled', false);
											}, 500);
										},
									},
									nao: {
										text: '<u>N</u>ão',
										keys: ['n', 'N'],
										action: function () {
											$('#edqtditemedicao').focus();
											setTimeout(() => {
												$('#btnsalvaritem').prop('disabled', false);
											}, 500);
											return;
										}
									}
								}
							});
						}
					} else {
						
						// Se o produto ainda não foi adicionado, incrementa o valor de vitem e cria um novo item
						vself.vitem = vself.lstitens.length === 0 ? 0 : vself.lstitens[vself.lstitens.length - 1].item;
						vself.vitem++;

						let itemtmp = {
							idproduto: 				vself.vidprodutoedicao,
							descproduto: 			vself.vdescricaoprodutoedicao,
							coddig: 				vself.vcoddigedicao,
							item: 					vself.vitem,
							qtditem: 				parseFloat(vself.vqtditemedicao),
							unditem: 				vself.vundprodutoedicao,
							vlunitario: 			parseFloat(vself.vvlunitarioedicao),
							prvendaminimo: 			parseFloat(vself.vprvendaminimo),
							descacres: 				vself.vdescacresedicao,
							tipodescacres: 			vself.vtipodescacresedicao,
							valordescacres: 		parseFloat(vself.vvalordescacresedicao),
							manipulaval: 			vself.vmanipulavaledicao,
							vltotal: 				parseFloat(vself.vvltotaledicao),
							vltotalimposto: 		parseFloat(vself.vvltotalimpostoitemedicao),
							idestoque: 				vself.videstoqueedicao,
							descestoque: 			$('#cbestoqueedicao').select2('data')[0]['text'],
							infadprod: 				vself.vinfadprod,
							qtdentregar: 			parseFloat(vself.vqtditemedicao),
							idtecnicosolicita: 		vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
							nometecnicosolicita: 	vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']
						};
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);
						vself.lstitens.push(itemtmp);
						vself.vtotalgeral = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos) + parseFloat(vself.vtotfrete);
						vself.vquantitativo = parseFloat(vself.vquantitativo) + parseFloat(vself.vqtditemedicao);
						vself.vqtditens = vself.lstitens.length;

						// Limpa os campos de edição e foca no próximo item
						vself.MtdLimparEdicaoItem();
						$('#edidprodutoedicao').focus();
						setTimeout(() => {
							$('#btnsalvaritem').prop('disabled', false);
						}, 500);
						
					}
				} else {
					// Se o item está sendo editado (vopitem != 1)
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.vvltotal_old_edicao);

					// Cria uma cópia da lista de itens e remove o item antigo
					let lsttmp = JSON.parse(JSON.stringify(this.lstitens));
					let indiceitem = util.getArrayIndexForKey(lsttmp, 'item', this.vitemalteracao);
					this.lstitens = [];

					this.vquantitativo = parseFloat(this.vquantitativo) - parseFloat(lsttmp[indiceitem].qtditem);

					// Atualiza os dados do item com as novas informações
					lsttmp[indiceitem].descproduto = this.vdescricaoprodutoedicao;
					lsttmp[indiceitem].qtditem = parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].unditem = this.vundprodutoedicao;
					lsttmp[indiceitem].vlunitario = parseFloat(this.vvlunitarioedicao);
					lsttmp[indiceitem].prvendaminimo = parseFloat(this.vprvendaminimo);
					lsttmp[indiceitem].descacres = this.vdescacresedicao;
					lsttmp[indiceitem].tipodescacres = this.vtipodescacresedicao;
					lsttmp[indiceitem].valordescacres = parseFloat(this.vvalordescacresedicao);
					lsttmp[indiceitem].manipulaval = this.vmanipulavaledicao;
					lsttmp[indiceitem].vltotal = parseFloat(this.vvltotaledicao);
					lsttmp[indiceitem].vltotalimposto = parseFloat(this.vvltotalimpostoitemedicao);
					lsttmp[indiceitem].idestoque = this.videstoqueedicao;
					lsttmp[indiceitem].descestoque = $('#cbestoqueedicao').select2('data')[0]['text'];
					lsttmp[indiceitem].infadprod = this.vinfadprod;
					lsttmp[indiceitem].qtdentregar = parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].idtecnicosolicita = this.vidtecnicosolicitaedicao === null ? 0 : this.vidtecnicosolicitaedicao;
					lsttmp[indiceitem].nometecnicosolicita = this.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text'];

					// Atualiza os totais e a lista de itens
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.vvltotaledicao);
					this.lstitens = JSON.parse(JSON.stringify(lsttmp));
					this.vtotalgeral = parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete);

					this.vquantitativo = parseFloat(this.vquantitativo) + parseFloat(this.vqtditemedicao);
					this.vqtditens = this.lstitens.length;

					// Fecha o modal de edição e habilita o botão salvar
					$('#mdedicaoitem').modal('hide');
					setTimeout(() => {
						$('#btnsalvaritem').prop('disabled', false);
					}, 500);
				}
	
			},
			MtdExcluirItem(item){
				if (!util.opcaousuario('020Z.010Z.130Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}				
				let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item);

				//this.vtotalimpostos = parseFloat(this.vtotalimpostos) - parseFloat(this.lstitens[indiceitem].vltotalimposto);

				this.vquantitativo  = parseFloat(this.vquantitativo)  - parseFloat(this.lstitens[indiceitem].qtditem);

				this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.lstitens[indiceitem].vltotal);

				this.vtotalgeral	=  parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete);

				this.lstitens.splice(indiceitem, 1);
				
				this.vqtditens	   = this.lstitens.length;					
			},
            MtdAplicarDesconto(){
				if (this.lstitens.length === 0){
					this.$toastr.i('Não há itens para lançamento do desconto!', 'Informação!');
				}else{
					if (parseInt(this.vpermitedesconto) === 0){
						this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
						return;
					}
					for (let i = 0; i < this.lstitens.length; i++) {
						if (parseFloat(this.lstitens[i].vltotalimposto) > 0){
							this.$toastr.i('Alguns itens possuem imposto atrelado. Desconto deve ser aplicado individualmente!', 'Informação!');
							return;
						}
					}
					this.vtipodesctotal		 = 0;
					this.vfatordescontototal = 0;
					this.vtotalsemdesconto   = 0;
					this.vresdesconto		 = 0;
					for (let item of this.lstitens) {
						this.vtotalsemdesconto = parseFloat(this.vtotalsemdesconto) + (item.vlunitario * item.qtditem);
					}
					this.vtotalcomdesconto	   = parseFloat(this.vtotalsemdesconto);
					$('#mdaplicardesconto').modal('show');
				}
			},
            MtdVisualiza(oprel){                
                return util.opcaousuario(oprel, this.$store.state.perfilusuario);
            },
			MtdFormataValorDecimal(valor, digitos){
                if (parseFloat(valor) > 0){
				    return util.formatavalordecimais(valor, digitos);
                }else{
                    return 0;
                }
			},          
			MtdFormatarZeros(str, length){ 
				return util.formatarzeros(str, length);
			},    
            MtdExecutaPesquisa(){
                var vself           = this;
                let filtro          = vself.MtdFiltroPesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.MtdCarregaAgendamentos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            MtdCarregaAgendamentos(ipagina, idagendantigo = null, idagendanovo = null){
				var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.MtdFiltroPesquisa(idagendantigo, idagendanovo);
                let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
                retorno.then(function (response) {
                    vself.lstagendamentos 	= response.data.agendamentos;
                    vself.ptotalcusto 		= response.data.totalcusto;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstagendamentos 	= [];
                    loader.hide();
                });
            },
            MtdFiltroPesquisa(idagendantigo, idagendanovo){
                let rfiltro = '';     
				if(idagendantigo && idagendanovo){
					rfiltro = ' and ag.idagendamento='+idagendanovo+ 
					' OR ag.idagendamento= '+idagendantigo;
				}else{
					if (this.pidagendamentopet !== ''){
						rfiltro = ' and ag.idagendamento='+this.pidagendamentopet;
					}
					if (parseInt(this.pstpagamentopet) < 3){
						rfiltro = rfiltro +' and ag.stpagamento='+this.pstpagamentopet;
					}
				}      
                if (this.pidfilialpet){
                    rfiltro = rfiltro +' and ag.idfilial='+this.pidfilialpet;
                }        
                if (this.pidclientepet){
					rfiltro = rfiltro +' and ag.idcliente='+this.pidclientepet;
                }        
				if (util.Trim(this.pchippet)){
					rfiltro = rfiltro +' and p.chip='+this.pchippet;
				}    
				if (parseInt(this.pstagendamentopet) < 3){
					rfiltro = rfiltro +' and ag.stagendamento='+this.pstagendamentopet;
				}
				if(parseInt(this.pfiltroperiodo) === 1){
					if (parseInt(this.pfiltropor) === 0){
						rfiltro = rfiltro + ' and ag.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}else{
						rfiltro = rfiltro + ' and ag.dtagendamento between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}
				}         
                return rfiltro;
            },
            ResetarDados() {
                util.toTop();
                this.valertarcliente        = false;
                this.vidagendamentopet      = '';
                this.vidfilialpet           = null;
                this.vdtemissaopet          = util.DataAtual(true);
                this.vdtagendamentopet      = util.DataAtual(true);
                this.phrag                  = util.HoraAtual(false, true);
                this.vidclientepet          = '';
                this.vnomeclientepet        = '';
                this.vpet                   = null;
                this.vagendamentopet        = 0;
                this.vpagamentopet          = 0;
                this.vbuscapet              = 0;
                this.ventregapet            = false;
                this.vdtentregapet          = util.DataAtual(true);
                this.vresponsavelpet        = '';
                this.vtelefonepet           = '';
                this.vobservacoes           = '';
                this.vreservar			    = false;
				this.vidplano				= null;
				this.vtipoplano				= 0;
                this.lstitens        		= [];
				this.lstplanos				= [];
				this.lstservicos			= [];
				this.vtotalgeral			= 0;
				this.vimagempet           	= ''; 

                $("#cbfilialpet").val(null).trigger('change');
                $("#cbpet").val(null).trigger('change');
				util.toTop();
                this.vid                = '';
				this.vidfilial          = this.$store.state.filialpadrao.codfil;
				this.vidcliente			= '';
				this.vnomecliente		= '';
				this.vidvendedor		= this.$store.state.usuario.idvendedor;
				this.vidtabela			= null;												
				this.vpercentrada		= 0;
				this.vpermitedesconto   = 0;
				this.vtotalprodutos		= 0;
				this.vtotalservicos		= 0;
				this.vidinfcpl          = null;
				this.vinfcpl            = '';
				this.vobservacoes		= '';
				this.vtotfrete          = 0;
				this.sringaleatoria     = '';
				//this.vtotalimpostos		= 0;
				this.vqtditens			= 0;
				this.vquantitativo		= 0;
				this.vdtfatura			= '';
				this.ventregaexterna	= false;
				this.vmostraestoque     = false;
				
				this.vitem				= 0;//contador dos itens
				
				$('#cbinfcpl').val(null).trigger('change');
				$("#cbservico").val(null).trigger('change');
				$("#cbprofissional").val(null).trigger('change');
				$("#cbmarcapesq").val(null).trigger('change');
				$("#cbgrupopesq").val(null).trigger('change');
            },
			ProcessaProdutos(items){
				for (let index = 0; index < items.length; index++) {

					let ret = util.itemcomimposto(this.MtdClasseItem(items[index].prod.classes), items[index].prod.prtabela, items[index].qtd, 0, 0);
					   
						if(util.findValInArray(this.lstitens, 'idproduto', items[index].id)){ ///se ja existir na listagem
							
							if (!util.opcaousuario('020Z.010Z.075Z', this.$store.state.perfilusuario)){
								this.$toastr.i('Item já incluso no pedido. Favor utilizar alteração para manipular a quantidade.', 'Informação!');
								return;
							}

							let ind = util.getArrayIndexForKey(this.lstitens, 'idproduto', items[index].id);

							let retalt = util.itemcomimposto(this.MtdClasseItem(items[index].prod.classes), items[index].prod.prtabela, items[index].qtd, 0, 0);
							
							this.lstitens[ind].qtditem        = this.lstitens[ind].qtditem + items[index].qtd;
							this.lstitens[ind].vltotal        = this.lstitens[ind].vltotal + retalt.vltotalitem;
							this.lstitens[ind].vltotalimposto = this.lstitens[ind].vltotalimposto + retalt.totalimpostoitem;
							this.lstitens[ind].qtdentregar    = this.lstitens[ind].qtditem;

							this.vqtditens			= this.lstitens.length;
							this.vquantitativo		= this.vquantitativo + parseFloat(items[index].qtd);							
														
						}else{
							let itl = this.lstitens.length === 0 ? 0 : this.lstitens[this.lstitens.length - 1].item;
							let itemtmp = {
								idproduto		    : items[index].id,
								descproduto		    : items[index].prod.descricao, //trazer do payload
								coddig			    : items[index].id,
								item			    : itl + 1,//this.lstitens.length + 1,
								qtditem			    : items[index].qtd, //trazer do payload,
								unditem			    : items[index].prod.und, //trazer do payload,
								vlunitario		    : items[index].prod.prtabela, //trazer do payload,
								descacres		    : 0,
								tipodescacres	    : 0, 
								valordescacres	    : 0,
								manipulaval		    : 0,
								vltotal			    : ret.vltotalitem,      //trazer do payload, 
								vltotalimposto      : ret.totalimpostoitem, //trazer do payload,
								idestoque		    : this.$store.state.filialpadrao.idestoque,
								descestoque		    : this.$store.state.filialpadrao.descestoque, //não sei como, mas vou dar um jeito de trazer do payload tambem,
								infadprod		    : '',
								qtdentregar		    : items[index].qtd, //trazer do payload, 
								idtecnicosolicita   :  0,
								nometecnicosolicita : ''						
							};	
							this.lstitens.push(itemtmp);

							this.vqtditens			= this.lstitens.length;
							this.vquantitativo		= this.vquantitativo + parseFloat(items[index].qtd);							
						}
				}
				this.MtdRecalcularPrecos();
			},
			MtdConsultarProduto(){
				if (parseInt(this.vopitem) === 1){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
			MtdLocalizarProduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id; //
							vself.vdescricaoprodutoedicao 	= produto.descricao; //
							vself.vundprodutoedicao			= produto.und; //
							vself.vfracionadoedicao			= produto.fracionado;//
							vself.vvltabelaitemedicao		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);
							vself.vvltabelaitemedicao 		= parseFloat(vself.vvltabelaitemedicao).toFixed(2);//acrescentei essa linha pra arredondar o valor
							vself.vvlunitarioedicao			= vself.vvltabelaitemedicao;

							vself.vqtdminimodescedicao      = vself.MtdPegaDadosDescTabela(1, produto.tabelas, vself.vidtabela)
							vself.vvldescontoqtdmin         = vself.MtdPegaDadosDescTabela(2, produto.tabelas, vself.vidtabela)							

							vself.vprvendaminimo			= produto.prvendaminimo;
							vself.vdadosclasseitem			= vself.MtdClasseItem(produto.classes);

							let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);

							//carrega o desconto promocional
							vself.vldescpromocionalitemedicao= produto.tabelas[it].vldescpromocional

							if (parseFloat(produto.tabelas[it].vldescpromocional) > 0){
								vself.alteraentra = true;
								vself.vdescacresedicao		= 0;
								vself.vtipodescacresedicao  = 0;
								vself.vvalordescacresedicao = parseFloat(produto.tabelas[it].vldescpromocional);						
							}
							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.MtdLimparEdicaoItem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.MtdLimparEdicaoItem();
				}
            },	
			MtdRecalcularPrecos(){
				let vself 		= this;
				let lstitenstmp = [];
				
				vself.vqtditens		= vself.lstitens.length;
				vself.vquantitativo = 0;
				for (let item of vself.lstitens) {
					vself.vquantitativo = vself.vquantitativo + item.qtditem;
					let itemtmp = {
						idproduto		: item.idproduto,
						item			: item.item
					};
					lstitenstmp.push(itemtmp);
				}
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',           valor : 'precosplano'},
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idfilial',     valor : vself.vidfilialpet},
					{parametro: 'idtabela',     valor : vself.vidtabela},
					{parametro: 'itens',    	valor : JSON.stringify(lstitenstmp)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
				retorno.then(function (response) {
					$('#mdselecionarplano').modal('hide');					
					vself.vtotalgeral	=  vself.vtotalgeral - vself.vtotalprodutos;
					vself.vtotalprodutos = 0;

					let lstitenscopia = [];
					lstitenscopia     = JSON.parse(JSON.stringify(vself.lstitens));					
					let lstitensret   = response.data;
					for (let item of lstitensret) {						
						let indi = util.getArrayIndexForKey(lstitenscopia, 'item', item.item);					
						
						let valdescacres = 0;

						if (parseInt(lstitenscopia[indi].manipulaval) === 0){							
							lstitenscopia[indi].vlunitario 		= parseFloat(item.vlunitario);
							lstitenscopia[indi].descacres		= 0;

							if (parseFloat(item.vldescpromocional) > 0){								
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= parseFloat(item.vldescpromocional);
								lstitenscopia[indi].manipulaval		= 0;

								valdescacres 		= parseFloat(lstitenscopia[indi].qtditem) * item.vlunitario * lstitenscopia[indi].valordescacres / 100;
															
							}else{
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= 0;
								lstitenscopia[indi].manipulaval		= 0;							
							}

							let ret = util.itemcomimposto(item.dadosclasseitem, parseFloat(item.vlunitario), parseFloat(lstitenscopia[indi].qtditem), 0, parseFloat(valdescacres));								

							lstitenscopia[indi].vltotalimposto  = ret.totalimpostoitem;
							lstitenscopia[indi].vltotal	   		= ret.vltotalitem;	

						}
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(lstitenscopia[indi].vltotal);
					}
					vself.lstitens	    = [];
					vself.lstitens	    = lstitenscopia;

					vself.vtotalgeral	=  parseFloat(vself.vtotalgeral) + parseFloat(vself.vtotalprodutos);					

					loader.hide();
				}).catch(function (response) {
					$('#mdselecionarplano').modal('hide');
					vself.$toastr.e('Erro ao tentar carregar os preços do plano de pagamento. Descrição do erro: '+response.message, 'Erro!');
					loader.hide();
				});
			},
            MtdPreparaCrud(op) {
                let vself    	= this;
				vself.opcrud 	= op;
                $('.nav-tabs a[href="#dvprodutos"]').tab('show');
                vself.MtdDefault();
				vself.sringaleatoria = util.GerarStringAleatoria()
            },
            MtdNovo(){
                if (!util.opcaousuario('020Z.050Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DO AGENDAMENTO PET';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
					this.ResetarDados();
                    this.MtdPreparaCrud(1);
                }
            },
			MtdQuantidade(op){
				if (parseInt(op) === 1){
					this.vqtditemedicao++;
				}else{
					if (parseFloat(this.vqtditemedicao) > 1){
						this.vqtditemedicao--;
					}
				}
				this.MtdVerificaDescontoQuantidade();
			},
			MtdVerificaDescontoQuantidade(){
				if(parseFloat(this.vqtdminimodescedicao) > 0){
					if(this.vqtditemedicao >= this.vqtdminimodescedicao){
						this.vtipodescacresedicao = 1;
						this.vvalordescacresedicao = this.vvldescontoqtdmin * parseFloat(this.vqtditemedicao);
				    }else{
						this.vvalordescacresedicao = 0;
					}
				}
			},
            MtdGravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.MtdRegistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },
            MtdLocalizarRegistro(id, idcliente = null){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and ag.idagendamento='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                    {parametro: 'idcliente',    valor : idcliente},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
                retorno.then(function (response) {
                    loader.hide();
					if (parseInt(response.data.agendamentos[0].stpagamento) !== 0){
						vself.$toastr.i('Para ALTERAR ou EXCLUIR o agendamento, a situação do mesmo deve estar em aberto!', 'Informação!');
						vself.MtdCancelarEdicao();
						return;
					}
					if (parseInt(response.data.agendamentos[0].liberarpdv) === 1){
						vself.$toastr.i('Para ALTERAR ou EXCLUIR o agendamento, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
						vself.MtdCancelarEdicao();
						return;
					}
                    vself.MtdIgualarCampos(response.data.agendamentos[0]);
                    $('#btgravar').focus();
                }).catch(function (response) {
                    loader.hide();
                });
            },
            MtdAlterar(item){
				$('#mdmenupedido').modal('hide');
                if (!util.opcaousuario('020Z.050Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
					if(parseInt(item.stagendamento) === 2){
						this.$toastr.i('Não é possível alterar um agendamento cancelado!', 'Informação!');
						return;
					}
					if(parseInt(item.stpedido) === 1){
						this.$toastr.i('Não é possível alterar, pedido já faturado!', 'Informação!');
						return;
					}
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DO AGENDAMENTO PET';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.MtdPreparaCrud(2);
                    this.MtdLocalizarRegistro(item.idagendamento, item.idcliente);
                }
            },
            MtdExcluir(item){
				$('#mdmenupedido').modal('hide');
                if (!util.opcaousuario('020Z.050Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DO AGENDAMENTO PET';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.MtdPreparaCrud(3);
                    this.MtdLocalizarRegistro(item.idagendamento, item.idcliente);
                }
            },
			MtdRotinaPdv(idagendamento, item){
				console.log(item)
				$('#mdmenupedido').modal('hide');
				if(parseInt(item.stpedido) === 1){
					this.$toastr.i('Para liberação/Bloqueio do pedido para o PDV, o mesmo deve estar com a situação em ABERTO!', 'Informação!');
					return;
				}
				if (!util.opcaousuario('020Z.050Z.040Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					let vself  = this;
					let loader = vself.$loading.show();
					let joinaux 	= "";
					let parametros      = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'rotinapdv'},
						{parametro: 'idagendamento',valor : idagendamento},
						{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        valor : '020Z.050Z.040Z'},
						{parametro: 'infcredito',   valor : 1},	
						{parametro: 'joinaux',   	valor : joinaux},										
						{parametro: 'idforma',      valor : vself.pidforma},
						{parametro: 'opconf',       valor : util.opcaousuario('020Z.010Z.036Z', this.$store.state.perfilusuario) ? 1 : 0},

					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
					retorno.then(function (response) {
						console.log(response)
						loader.hide();
						if ($.isNumeric(response.data.ret)){
							vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
							// vself.pfiltropor		= 0;
							// vself.psituacao     	= 3;
							// vself.pentregaexterna 	= 2;
							// vself.pidpedido     	= idpedido;
							// vself.pqtd_paginas  	= 1;
							// vself.MtdCancelarEdicao();
							// vself.mtdcarregapedidos(1);
							vself.MtdAtualizaAgendamentoLista(response.data.agendamento[0], idagendamento)
						}else{
							let tpret = response.data.ret.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						loader.hide();
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});
				}				
			},
			MtdAtualizaAgendamentoLista(agendamento, idagendamento){
				let legagendamentos     = JSON.parse(JSON.stringify(this.lstagendamentos));
				this.lstagendamentos    = [];
				
				let ind = util.getArrayIndexForKey(legagendamentos, 'idagendamento', idagendamento);
				legagendamentos[ind]    = agendamento;
				
				this.lstagendamentos    = JSON.parse(JSON.stringify(legagendamentos));
				
			},
			MtdRemarcarAgendamento(item){
				let vself = this;
				$('#mdmenupedido').modal('hide');
				if (!util.opcaousuario('020Z.050Z.050Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
					if(parseInt(item.stagendamento) === 2){
						vself.$toastr.i('Não é possível REMARCAR um agendamento cancelado!', 'Informação!');
						return;
					}
					if (parseInt(item.liberarpdv) === 1){
						vself.$toastr.i('Para REMARCAR o agendamento, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
						return;
					}
					$('#mdremarcaragendamento').modal('show');
                    vself.itensbc.item2.titulo = 'ALTERAÇÃO DO AGENDAMENTO PET';
                    vself.itensbc.item1.ativo = true;
                    vself.itensbc.item2.ativo = true;
                    vself.ativadesativa = false;
                    vself.MtdLocalizarRegistro(item.idagendamento, item.idcliente);
                }
			},
			MtdConfirmaNovoAgendamento(idagendantigo) {
				let vself = this;
				let loader = vself.$loading.show();
				
				let dataAgendamento = vself.vdtagendamentopet.split(' ')[0];
				
				let partesData = dataAgendamento.split('/');
				let dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`; 
				
				let dataHoraAgendamento = `${dataFormatada} ${vself.phrag}:00`;

				let registrocrud = {
					'dtagendamento': dataHoraAgendamento,
					'stagendamento': vself.vagendamentopet,
				};

				let parametros = [
					{parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op', valor: 'remarcarAgendamento'},
					{parametro: 'idagendamento', valor: vself.vidagendamentopet},
					{parametro: 'registro', valor: JSON.stringify(registrocrud)},
					{parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario', valor: vself.$store.state.usuario.id},
					{parametro: 'codop',        		valor : '020Z.050Z.060Z'} //tem que gerar o codop
				];

				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadagendamentospet.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)) {
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.pentregaexterna 	= 2;
						vself.pqtd_paginas  	= 1;
						$("#cbfilialpesq").val(null).trigger('change');
						$("#cbclientepesq").val(null).trigger('change');
						vself.pfiltroperiodo 	= 0;
						vself.pstagendamentopet = 3;
						vself.pstpagamentopet   = 3;
						vself.ResetarDados();
						vself.MtdCarregaAgendamentos(1, idagendantigo, response.data);
					} else {
						vself.MtdCarregaAgendamentos(1);
						let tpret = response.data.substring(0, 1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E':
							default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registro. Descrição do erro: ' + response.message, 'Erro!');
					vself.MtdCarregaAgendamentos(1);
				});
			},
			MtdCancelarAgendamento(item){
				$('#mdmenupedido').modal('hide');				
				if (!util.opcaousuario('020Z.050Z.060Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{		
					if (parseInt(item.liberarpdv) === 1){
						this.$toastr.i('Para CANCELAR o agendamento, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
						return;
					}	
					if(parseInt(item.stagendamento) === 2){
						this.$toastr.i('Agendamento já cancelado!', 'Informação!');
						return;
					}	
					var vself       = this;
					let loader      = this.$loading.show();
					let filtro      = ' and ag.idagendamento='+item.idagendamento;
					let parametros  = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
					retorno.then(function (response) {
						loader.hide();
						vself.agendamentocancelar 	  = response.data.agendamentos[0];
						vself.MtdConfirmarCancelamento();										
					}).catch(function (response) {
						loader.hide();
					});
				}				
			},
			MtdConfirmarCancelamento(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma CANCELAMENTO?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.MtdEfetivaCancelamento();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});								
			},
			MtdEfetivaCancelamento(){
				let vself  = this;
				let loader = vself.$loading.show();
				let parametros      = [
					{parametro: 'idclientesac', 		valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           		valor : 'cancelamento'},
					{parametro: 'idagendamento',     	valor : vself.agendamentocancelar.idagendamento},
					{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
					{parametro: 'codop',        		valor : '020Z.050Z.060Z'}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						$('#mdcancelarpedido').modal('hide');
						vself.$toastr.s('Cancelamento realizado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.pentregaexterna 	= 2;
						vself.pidagendamentopet = vself.agendamentocancelar.idagendamento;
						vself.pqtd_paginas  	= 1;
						$("#cbfilialpesq").val(null).trigger('change');
						$("#cbclientepesq").val(null).trigger('change');
						vself.pfiltroperiodo 	= 0;
						vself.pstagendamentopet = 3;
						vself.pstpagamentopet   = 3;
						vself.MtdCarregaAgendamentos(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
            MtdIgualarCampos(registro){
				let horaAgendamento 				= registro.dtagendamento.split(" ")[1];
                this.vidagendamentopet 				= registro.idagendamento;
                this.vdtagendamentopet  			= registro.dtagendamento;
                this.phrag  						= horaAgendamento;
                this.vidclientepet  				= registro.idcliente;
                this.vnomeclientepet  				= registro.nomecliente;
				this.valertarcliente				= parseInt(registro.alertarcliente) === 0 ? false : true;
				this.vconteudoalerta				= registro.conteudoalerta;	
                this.vidfilialpet      				= registro.idfilial;
				this.vtotalprodutos					= registro.totalprodutos;
				this.vtotalservicos					= registro.totalservicos;
                this.vdtemissaopet	 				= registro.dtemissao;
                this.vdtentregapet	 				= registro.dtentrega;
                this.ventregapet	    			= parseInt(registro.entregapet) === 0 ? false : true;
                this.vbuscapet	     				= registro.buscapet;
                this.vobservacoes      				= registro.observacao;
                this.vtelefonepet      				= registro.telefone;                       
                this.vresponsavelpet   				= registro.responsavel;
                this.vagendamentopet   				= registro.stagendamento;
                this.vpagamentopet     				= registro.stpagamento;
				this.vidplano						= registro.idplano;
				this.vtipoplano						= registro.tipoplano;
				this.vdescplano						= registro.descplano;
				this.lstservicos					= registro.servicos;
				this.lstitens						= registro.itens;
				this.vqtditens						= registro.itens.length;
				this.vtotalprodutos					= registro.totalprodutos;
				this.vtotalservicos					= registro.totalservicos;
				this.vtotalgeral					= registro.totalgeral;
                this.vreservar						= parseInt(registro.reservar) === 0 ? false : true;
				this.vtotfrete          			= registro.totfrete;
				this.vpet          					= registro.idpet;
                
                var deffilial  = new Option(registro.fantasiafil, registro.idfilial, true, true);
				$('#cbfilialpet').append(deffilial).trigger('change');
                
                var defpet  = new Option(registro.nomepet, registro.idpet, true, true);
				$('#cbpet').append(defpet).trigger('change');


				
                this.vitem					= registro.itens.length === 0 ? 0 : registro.itens[registro.itens.length - 1].item;
				this.vidplano				= registro.idplano;
				this.vtipoplano				= registro.tipoplano;
				this.vdescplano				= registro.descplano;
				this.vidtabela				= registro.idtabela;
				this.vpercentrada			= registro.percentrada;
				this.vpermitedesconto		= registro.permitedesconto;
				this.vquantitativo			= registro.quantitativo;

            },
            MtdRegistro() {
				let vself = this;
				let loader = vself.$loading.show();
				let apenasData = vself.vdtagendamentopet.split(' ')[0];
				let dataHoraAgendamento = `${apenasData} ${vself.phrag}:00`;

				// let dataHoraAgendamento = `${vself.vdtagendamentopet} ${vself.phrag}:00`;

				let registrocrud = {
					'idagendamento'     : vself.vidagendamentopet,
					'idfilial'          : vself.vidfilialpet,
					'dtemissao'         : vself.vdtemissaopet,
					'dtagendamento'     : dataHoraAgendamento,
					'idcliente'         : vself.vidclientepet,
					'idpet'             : vself.vpet,
					'totalprodutos'     : vself.vtotalprodutos,
					'totalservicos'     : vself.vtotalservicos,
					'stagendamento'     : vself.vagendamentopet,
					'stpagamento'       : vself.vpagamentopet,
					'buscapet'          : vself.vbuscapet,
					'entregapet'        : vself.ventregapet,
					'dtentrega'         : vself.vdtentregapet,
					'observacao'        : vself.vobservacoes,
					'responsavel'       : vself.vresponsavelpet,
					'telefone'          : (vself.vtelefonepet !== '' && vself.vtelefonepet !== null) ? vself.vtelefonepet.replace(/[^0-9]/g,'') : '',
					'idplano'           : vself.vidplano,
					'itens'             : vself.lstitens,
					'totalgeral'        : vself.vtotalgeral,
					'servicos'          : vself.lstservicos,
					'reservar'          : vself.vreservar === false ? 0 : 1,
					'totfrete'          : vself.vtotfrete,
				};

				let parametros = [
					{parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor: 'rotinacrud'},
					{parametro: 'opcrud',       valor: vself.opcrud},
					{parametro: 'registro',     valor: JSON.stringify(registrocrud)},
					{parametro: 'idfilial',     valor: vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor: vself.$store.state.usuario.id},
					{parametro: 'codop',        valor: parseInt(this.opcrud) === 1 ? '010Z.005Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.005Z.020Z' : '010Z.005Z.030Z'},
				];
				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadagendamentospet.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)) {
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ResetarDados();
						vself.pidagendamentopet = parseInt(vself.opcrud) === 1 || parseInt(vself.opcrud) === 2 ? response.data : vself.vidagendamentopet;
						vself.MtdCancelarEdicao();
						vself.MtdCarregaAgendamentos(1);
					} else {
						vself.MtdCarregaAgendamentos(1);
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registro. Descrição do erro: ' + response.message, 'Erro!');
					vself.MtdCarregaAgendamentos(1);
				});
			},
			MtdConfirmaAplicacaoDesconto(){				
				let fatoraplicar 		= 0;
				if (parseInt(this.vtipodesctotal)){
					fatoraplicar = parseFloat(this.vresdesconto);					
				}else{
					fatoraplicar = parseFloat(this.vfatordescontototal);
				}
				
				let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

				if (parseFloat(fatoraplicar) > parseFloat(descto_comparar)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
					$('#cbtipodesctotal').focus();					
					return;
				}

				if (parseFloat(fatoraplicar) < 0){
					this.$toastr.w('Desconto inválido!', 'Informação!');
					$('#edfatordescontototal').focus();
					return;
				}

				if (fatoraplicar > 0){
					for (let item of this.lstitens) {
						if (((parseFloat(item.vlunitario) * parseFloat(item.qtditem)) * parseFloat(fatoraplicar) / 100) < 0.01){
							this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
											'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
							return;
						}
					}
				}
				$('#btnconfirmadesconto').prop('disabled', true);
				this.vtotalgeral		= parseFloat(this.vtotalgeral) - parseFloat(this.vtotalprodutos);				
				this.vtotalprodutos		= 0;
				let descacumulado 		= 0;
				let mandarmsg           = false; 
				let vldesconto			= 0;

				for (var i = 0; i < this.lstitens.length; i++) {
					let dardesc = true;
					//verfica o preco de venda mínimo
					if (parseFloat(this.lstitens[i].prvendaminimo) > 0){
						let vldescpm = 0;
						vldescpm = parseFloat(this.lstitens[i].vlunitario) - (parseFloat(this.lstitens[i].vlunitario) *  parseFloat(fatoraplicar) / 100);

						if (parseFloat(this.lstitens[i].prvendaminimo) > parseFloat(vldescpm)){
							//this.$toastr.i('O item: '+this.lstitens[i].item+' ultrapassou o preço mínimo. Desconto deve ser aplicado individualmente!', 'Informação!');
							//$('#btnconfirmadesconto').prop('disabled', false);
							//return;		
							dardesc   = false;
							mandarmsg = true;

						}								
					}else{
						vldesconto 	= (parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) * parseFloat(fatoraplicar) / 100;
					}


					//let vldesconto 			= (parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) * parseFloat(fatoraplicar) / 100;
					
					if (vldesconto < 0.01){
						descacumulado = parseFloat(vldesconto);
					}else{
						descacumulado = 0;
					}

					vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
					if(dardesc){
						if (vldesconto >= 0.01){
							this.lstitens[i].descacres		= 0;
							this.lstitens[i].tipodescacres	= 1;
							this.lstitens[i].valordescacres	= parseFloat(vldesconto) + parseFloat(descacumulado);
							descacumulado = 0;
							this.lstitens[i].vltotal		= util.arredondaValores((parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) - parseFloat(vldesconto), 2, 'round');
						}else{
							this.lstitens[i].valordescacres	= 0;
							this.lstitens[i].vltotal		= util.arredondaValores(parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem), 2, 'round');
						}
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);
					}
				
					
				}

				this.vtotalprodutos 	= util.arredondaValores(parseFloat(this.vtotalprodutos), 2, 'round');

				this.vtotalgeral		= parseFloat(this.vtotalgeral) + parseFloat(this.vtotalprodutos);	
				
				let vlajuste = 0;
				let ajustar  = 0;
				if (parseFloat(this.vtotalcomdesconto) > parseFloat(this.vtotalprodutos)){
					vlajuste = parseFloat(this.vtotalcomdesconto) - parseFloat(this.vtotalprodutos);
					ajustar  = 1;//ajuste para menos
				}else{
					vlajuste = parseFloat(this.vtotalprodutos) - parseFloat(this.vtotalcomdesconto);
					ajustar  = 0;//ajuste para mais
				}
				if (vlajuste > 0 && vlajuste < 0.01){
					vlajuste = 0.01;
				}
				if (vlajuste > 0){
					for (var x = 0; x < this.lstitens.length; x++) {
						if (parseFloat(this.lstitens[x].vltotal) > vlajuste){
							if (ajustar === 0){//ajuste para mais
								this.lstitens[x].valordescacres	= util.arredondaValores(parseFloat(this.lstitens[x].valordescacres) + parseFloat(vlajuste), 2, 'round');
							}else{//ajuste
								this.lstitens[x].valordescacres	= util.arredondaValores(parseFloat(this.lstitens[x].valordescacres) - parseFloat(vlajuste), 2, 'round');
							}							
							if (this.lstitens[x].valordescacres < 0){
								this.lstitens[x].valordescacres = 0;
							}
							this.lstitens[x].vltotal		= (parseFloat(this.lstitens[x].vlunitario) * parseFloat(this.lstitens[x].qtditem)) - parseFloat(this.lstitens[x].valordescacres);							
							break;
						}
					}
					if (parseInt(ajustar) === 0){
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    - parseFloat(vlajuste);
					}else{
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    + parseFloat(vlajuste);						
					}					
				}	
				this.MtdRecalcularTudo(mandarmsg)		
				$('#mdaplicardesconto').modal('hide');
				setTimeout(() => {
					$('#btnconfirmadesconto').prop('disabled', false);
				}, 500);
			},
			MtdRecalcularTudo(mandarmsg){
				this.vtotalprodutos = 0;
				for(let i = 0; i < this.lstitens.length; i++){
					this.vtotalprodutos = this.vtotalprodutos + this.lstitens[i].vltotal
				}
				this.vtotalgeral =  this.vtotalprodutos + this.vtotalservicos;
				if(mandarmsg){
					 this.$toastr.i('Desconto aplicado, mas um ou mais itens atingiram o preço minimo, seu desconto pode ser dado individualmente!', 'Atenção!');
				}
			},	
            MtdCalculaTotalItem(){
                this.vtotalitemedicao = parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao);
            },       
            CarregaPets(idcliente) {
				let vself = this;
				let sqlinipet = 'SELECT idpet, nome FROM tbpetscliente '
				let sqlfimpet = 'WHERE idcliente =' +idcliente
                $("#cbpet").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2sql,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini: sqlinipet,
								sqlfim: sqlfimpet,
								cpid: 'idpet',
								cpdesc: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vpet = $("#cbpet").val();
                });
            },
			MtdProcessaEstoquePro(produtos){
				let leglstitens = JSON.parse(JSON.stringify(this.lstitens));
				this.lstitens   = [];
				for (let index = 0; index < produtos.length; index++) {
					let ind = util.getArrayIndexForKey(leglstitens, 'item', produtos[index].item);
					leglstitens[ind].estoques = produtos[index].estoques
				}
				this.lstitens = JSON.parse(JSON.stringify(leglstitens));
			},
			MtdConsultarEstoqueItens(){
				let vself = this;
				if(this.lstitens.length > 0){
					let itens = [];
					for (let index = 0; index < this.lstitens.length; index++) {
						//////////////// 

						let itemtmp = {
							item      : this.lstitens[index].item,
							idproduto : this.lstitens[index].coddig,
							idestoque : this.lstitens[index].idestoque
						} 

                        itens.push(itemtmp);

						////////////////
					}

					let loader      = vself.$loading.show();
				
					let parametros  = [
						{parametro: 'op',           valor : 'estoquesprodutos'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'itens',        valor : JSON.stringify(itens)},
					
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						loader.hide();   
					    vself.MtdProcessaEstoquePro(response.data)
					}).catch(function (response) {
						loader.hide();
					});
				}
			},
			MtdVisualizarEstoque(item){
				this.idprodutoestoque = item.coddig;
				this.descproestoque   = item.descproduto;
				// $('#mdestoqueproduto2').modal('show');

				let payload = {
					abrirtela    : true,
					idproduto    : this.idprodutoestoque,
					descproduto  : this.descproestoque			
				};
				this.$store.commit('CONSULTA_ESTOQUE_CHANGE',payload);
			},
			MtdPegaDadosDescTabela(op, tabelas, idtabela){
				for (var i = 0; i < tabelas.length; i++) {
					if (parseInt(tabelas[i]['idtabela']) === parseInt(idtabela) ){
						if(op===1){
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseInt(tabelas[i]['qtdminima']);
						}else{
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseFloat(tabelas[i]['desconto']);
						}
					}    
				}
			},	
			MtdAtzVariaveisPerfil(){
				this.pmanipularvaloritem = util.opcaousuario('020Z.010Z.070Z', this.$store.state.perfilusuario) === false ? true : false;
				this.pdefinirestoque 	 = util.opcaousuario('020Z.010Z.080Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterardatafatura  = util.opcaousuario('020Z.010Z.100Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterarvendedor	 = util.opcaousuario('020Z.010Z.120Z', this.$store.state.perfilusuario);
			},
			MtdMostrarMenu(pedido){		
				this.pedidomenu = pedido;
				$('#mdmenupedido').modal('show');
			},
			MtdClasseItem(classes){
				let vself = this;
				if (classes.length > 0){
					let indc = util.getArrayIndexForKey(classes, 'idfilial', vself.vidfilialpet);
					if (indc > -1){
						return classes[indc];
					}else{
						return [];
					}
				}else{
					return [];
				}
			},
			MtdSelect2ServicoDef(){
				let vself = this;
				$("#cbservico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbservicos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidservicoedicao = $("#cbservico").val();
					if (vself.vidservicoedicao !== null){
						// let loader      = vself.$loading.show();
						let filtro      = ' and id='+vself.vidservicoedicao;
						let parametros  = [
							{parametro: 'op',           valor : 'listagem'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',       valor : filtro},
							{parametro: 'limit',        valor : 1},
							{parametro: 'offset',       valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadservicos.php');
						retorno.then(function (response) {
							// loader.hide();
							let servico = [];
							servico     = response.data[0];
							vself.vprecoservicoedicao = [];
							vself.vprecoservicoedicao = util.mtdcarregaprecoservicofilial(servico.precos, vself.vidfilial);
							vself.vvlservicoedicao 	  = vself.vprecoservicoedicao.vlservico;						
						}).catch(function (response) {
							// loader.hide();
						});	
					}				
				});
			},
			MtdLocalizarPlanos(){
				let vself = this;
				if (vself.vidfilialpet && vself.vidclientepet){	
					vself.vidplano  	= null;
					vself.vtipoplano	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;				
					vself.vpermitedesconto = 0;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',           valor : 'planospedido'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idfilial',     valor : vself.vidfilialpet},
						{parametro: 'idcliente',    valor : vself.vidclientepet}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						loader.hide();
						vself.lstplanos  = response.data;
					}).catch(function (response) {
						vself.lstplanos  = [];
						loader.hide();
					});				
				}else{
					vself.vidplano   	= null;
					vself.vtipoplano 	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;
					vself.vpermitedesconto = 0;
					vself.lstplanos  	= [];					
				}
			},
            MtdDefault(){
				let vself = this;
				$('#pnlista').hide();
				vself.ResetarDados();
				$('#pncadastro').fadeIn(700);
				setTimeout(function(){
                    if (parseInt(vself.opcrud) < 3) {
						$('#cbfilialpet').focus();					
                    } else {
						$('#btgravar').focus();						
                    }
				},200);
            },
            MtdCancelarEdicao(){
				let vself = this;
				if ((parseInt(this.opcrud) >= 0 && parseInt(this.opcrud) <= 2) && this.lstitens.length > 0){
					$.confirm({
						title: 'Confirmação!',
						content: 'Confirma CANCELAMENTO do agendamento em edição?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'orange',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									vself.MtdLimparEdicao();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});					
				}else{
					this.MtdLimparEdicao();
				}
            },
			MtdLimparEdicao(){
				this.opcrud 			= 0;
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;


                $('#pncadastro').hide();			
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
			},
            MtdLimparListagem() {
				// $( '#dvlistagempedidos .table-responsive' ).css('height', 'auto');
				let vself = this;
                vself.lstpedidos 	= [];
                vself.pagina_atual 	= 1;
                vself.filtro 		= '';
                vself.pqtd_total_registros 	= 0;
				vself.pqtd_paginas 			= 0;							
            },
			MtdHabilitaEdicaoDescPro(){
				this.vedicaodescpro = false;
				setTimeout(function(){
            		$('#eddescricaoprodutoedicao').focus();
        		}, 300); 				
			},
			MtdDesabilitaEdicaoDescPro(){
				this.vedicaodescpro = true;
			},	
			MtdTpDescAcres(val){				
				// if (parseInt(val) === 0){
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(%):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(%):';
				// 	}
				// }else{
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(R$):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(R$):';
				// 	}
				// }
				
				if (parseInt(val) === 0){
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: R$ '+this.MtdFormataValorDecimal(parseFloat(this.vldescmostrar), 2);
					}else{
						this.vtitdesc = 'Acresc.(%):';
					}
				}else{
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: '+this.MtdFormataValorDecimal(parseFloat(this.vldescmostrar), 2)+'%';
					}else{
						this.vtitdesc = 'Acresc.(R$):';
					}
				}					
			},
			MtdAdicionarServico(){
				if (this.vidservicoedicao === null){
					this.$toastr.w('Serviço deve ser informado!', 'Atenção!');
					$('#cbservico').focus();
					return;
				}
				if (this.vidprofissionaledicao === null){
					this.$toastr.w('Profissional deve ser informado!', 'Atenção!');
					$('#cbprofissional').focus();
					return;
				}
				if (!Number.isInteger(parseFloat(this.vqtdservicoedicao))){
					this.$toastr.w('Quantidade não permitida!', 'Atenção!');
					$('#edqtdservedicao').focus();
					return;
				}else{
					if (this.vqtdservicoedicao == 0){
						this.$toastr.w('Informe uma quantidade válida!', 'Atenção!');
						$('#edqtdservedicao').focus();
						return;
					}
				}
				if (this.vvlservicoedicao <= 0){
					this.$toastr.w('Informe o valor unitário do serviço!!', 'Atenção!');
					$('#edvlservicoedicao').focus();
					return false;
				}


				let fatd = 0;
				if (parseInt(this.vtipodescontoservicoedicao) === 0){
					fatd = this.vvalordescontoservicoedicao;
				}else{
					fatd = parseFloat(this.vvalordescontoservicoedicao) / (parseFloat(this.vqtdservicoedicao) * parseFloat(this.vvlservicoedicao)) * 100;
				}
				if (parseFloat(fatd) > parseFloat(this.$store.state.usuario.descontoservicos)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoservicos+'%!', 'Informação!');
					$('#edvalordescontoservicoedicao').focus();					
					return;
				}	

				if (util.findValInArray(this.lstservicos, 'idservico', this.vidservicoedicao)){	
					this.$toastr.w('Serviço já lançado na venda!', 'Atenção!');
					$('#cbservico').focus();
					return;					
				}
				let servico = {
					idservico		: this.vidservicoedicao,
					descservico		: $('#cbservico').select2('data')[0]['text'],
					qtdservico		: this.vqtdservicoedicao,
					vlservico		: parseFloat(this.vvlservicoedicao),
					tipodesconto	: this.vtipodescontoservicoedicao,
					valordesconto	: parseFloat(this.vvalordescontoservicoedicao),
					vltotal			: parseFloat(this.vvltotalservicoedicao),
					idtecnico		: this.vidprofissionaledicao,
					nometecnico		: $('#cbprofissional').select2('data')[0]['text']
				};
				this.lstservicos.push(servico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) + parseFloat(this.vvltotalservicoedicao);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete);

				this.vidservicoedicao				= null;
				this.vqtdservicoedicao				= 1;
				this.vvlservicoedicao				= 0;
				this.vtipodescontoservicoedicao		= 0;
				this.vvalordescontoservicoedicao	= 0;
				this.vvltotalservicoedicao			= 0;
				this.vidprofissionaledicao			= null;

				$("#cbservico").val('').trigger('change');
				$("#cbprofissional").val('').trigger('change');				

				$('#cbservico').focus();

			},
			MtdExcluirServico(servico){
				if (!util.opcaousuario('020Z.010Z.140Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}								
				let indiceservico 	= util.getArrayIndexForKey(this.lstservicos, 'idservico', servico.idservico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) - parseFloat(this.lstservicos[indiceservico].vltotal);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete);

				this.lstservicos.splice(indiceservico, 1);
			},
			MtdSelecionarPlano(){
				let vself = this;
				if (this.vidfilialpet === null){
					vself.$toastr.w('Filial deve ser informada!', 'Informação!');
					$('#cbfilialpet').focus();
					return;
				}				
				if (this.vidclientepet === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Informação!');
					$('#edcliente').focus();
					return;
				}
				$('#mdselecionarplano').modal('show');
			},
			MtdDefinePlano(plano) {
				this.vidplano 			= plano.id;
				this.vtipoplano 		= plano.tipo;
				this.vdescplano 		= plano.descricao;
				this.vidtabela 			= plano.idtabela;
				this.vpercentrada 		= parseFloat(plano.percentrada);
				this.vpermitedesconto 	= plano.permitedesconto;

				if (this.lstitens.length > 0) {
					if (!util.opcaousuario('020Z.010Z.031Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) !== 3) {
						this.MtdRecalcularPrecos();
						$('#mdselecionarplano').modal('hide');
						return
					} 
					$.confirm({
						title: 'Confirmação!',
						content: 'DESEJA RECALCULAR OS PREÇOS AO ALTERAR O PLANO?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: { // recalcular
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: () => {
									$('.btn-blue').prop('disabled', true);
									this.MtdRecalcularPrecos();
									$('#mdselecionarplano').modal('hide');
								},
							},
							nao: { // não recalcular
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: () => {
									$('#btgravar').focus();
									$('#mdselecionarplano').modal('hide');
								}
							}
						}
					});
			    }else{
					$('#mdselecionarplano').modal('hide');
				}
			},
			CarregaPetImagem(petId) {
			var vself = this;
			vself.isLoadingimgpet = true;

			
			let parametros = [
				{ parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
				{ parametro: 'idcliente', valor: vself.vidclientepet },
				{ parametro: 'idpet', valor: petId },  
				{ parametro: 'diretoriopet', valor: vself.$store.state.configpaths.pathimgpets + vself.$store.state.filialpadrao.idcliente },
				{ parametro: 'idfilial', valor: vself.$store.state.filialpadrao.codfil },
				{ parametro: 'op', 			valor: 'imagempet' },
			];

			let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadagendamentospet.php');

			retorno.then(function(response) {
				if (response.data && response.data[0].pets.length > 0) {
					let petData = response.data[0].pets[0];
					vself.vimagempet = vself.$store.state.configpaths.pathimagens + petData.srcimagempet.patharquivo.replace('../', '') + '?cb=' + Date.now();
				} else {
					vself.vimagempet = 'imagens/semimagem.png';  
				}
				setTimeout(() => {
					vself.isLoadingimgpet = false; 
				}, 700);
			}).catch(function(error) {
				vself.vimagempet = 'imagens/semimagem.png'; 
				setTimeout(() => {
					vself.isLoadingimgpet = false; 
				}, 700);
			});
		}
        },
        mounted: function () {
			if (util.verificasessao(this)) {
				let vself = this;
				vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
					$('[data-toggle="popover"]').popover();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('020Z.050Z', vself.$store.state.perfilusuario)) {
						vself.pathimgview         = vself.$store.state.configpaths.pathimagens;
						$('#pnlista').fadeIn(700);
						$('#edidpedidopesq').focus();
						vself.MtdAtzVariaveisPerfil();
						vself.MtdSelect2_Def();
						vself.MtdCarregaAgendamentos(1);
						vself.CarregaPetImagem();
						
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            };
        },
        computed:{
			calculatotalitem() {
				let valdescacres = 0;
				switch (parseInt(this.vtipodescacresedicao)) {
					case 0: // Percentual
						valdescacres = this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						break;
					case 1: // Valor
						valdescacres = this.vvalordescacresedicao;
						break;
				}
				
				// Chama a função itemcomimposto para calcular o total com imposto
				let ret = util.itemcomimposto(this.vdadosclasseitem, this.vvlunitarioedicao, this.vqtditemedicao, this.vdescacresedicao, valdescacres);

				// Atualiza os valores totais com os valores retornados
				this.vvltotalimpostoitemedicao = ret.totalimpostoitem;
				this.vvltotaledicao = ret.vltotalitem;
			},
            validou() {
                return this.vidfilialpet === null || this.vidclientepet === null || this.erroHorario === true ||
				this.vpet === null || this.vresponsavelpet === '' || this.vtelefonepet === '' || this.vidplano === null || 
				(this.lstitens.length === 0 && this.lstservicos.length === 0); ; 
            },
            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            idclienteretorno(){
                return this.$store.state.clienteretornoconsulta.idcliente;
			},
			manipulaval(){
				if (!this.alteraentra) {
					this.vtipodescacresedicao 	= 0;
					this.vvalordescacresedicao 	= 0;
					this.vtipodescacresedicao 	= 0;
					this.vdescacresedicao 	= 0;
				}
				switch (parseInt(this.vmanipulavaledicao)) {
					case 0:
						if (!this.alteraentra) {
							this.vvlunitarioedicao = this.vvltabelaitemedicao;
						}
						return true;
						break;
					case 1:
						return false;
						break;
				}
				this.alteraentra = false;
			},
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
		    listaprodutosretorno(){
                return this.$store.state.listaprodutosretornoconsulta.lstprod;
            },	
			calculatotalserv() {
				var valdescacres = 0;
				switch (parseInt(this.vtipodescontoservicoedicao)) {
					case 0://Percentual
						valdescacres = this.vqtdservicoedicao * this.vvlservicoedicao * this.vvalordescontoservicoedicao / 100;
						break;
					case 1://Valor
						valdescacres = this.vvalordescontoservicoedicao;
						break;
				}
				this.vvltotalservicoedicao = (this.vqtdservicoedicao * this.vvlservicoedicao) - valdescacres;
			},
			calculadescontototalitens(){
				if (parseInt(this.vtipodesctotal) === 0){
					this.vtotalcomdesconto = this.vtotalsemdesconto - (this.vtotalsemdesconto * this.vfatordescontototal / 100);
					this.vresdesconto	   = this.vfatordescontototal * this.vtotalsemdesconto / 100;						
				}else{
					this.vtotalcomdesconto = this.vtotalsemdesconto - this.vfatordescontototal;			
					this.vresdesconto	   = this.vfatordescontototal / this.vtotalsemdesconto * 100;			
				}
			},
            temItens(){
                return this.lstitensconf.length === 0
            },
        },
        watch:{
			// vvalordescacresedicao(){
			// 	this.calculatotalitem()
			// },
			// vdescricaoprodutoedicao(){
			// 	this.calculatotalitem()
			// },
			vpet(val){
				let vself = this;
				if(val){
					vself.CarregaPetImagem(val);
				}
			},
			idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.MtdLocalizarProduto(this.vcoddigedicao);					
                }
			},
			listaprodutosretorno(val){
				this.ProcessaProdutos(val);
			},	
            vidclientepet(newVal) {
                if (newVal) {
                    this.CarregaPets(newVal);
                }
            },
            vmostraestoque(val){
				this.columnsi[12].visibility = val;
				if(val){
					this.MtdConsultarEstoqueItens()
					
				}
			},
            ventregaexterna(val){
				this.columnsi[8].visibility = val;
				for (let i = 0; i < this.lstitens.length; i++) {
					this.lstitens[i].qtdentregar = this.lstitens[i].qtditem;					
				}
			},
            vvlunitarioedicao(val){
                this.MtdCalculaTotalItem(); 
            },
            idclienteretorno(val){
                if (val !== null || val !== ''){
					this.vidclientepet = val;
					this.MtdLocalizarCliente(this.vidclientepet);					
                }
			},
			vermelho(){
				if(!this.vermelho){
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: green;'
				}else{
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: rgb(128, 23, 0);'
				}
			},
			defsubs(){
				if(parseInt(this.defsubs)===1){	
					this.vermelho = false
				}else{
					this.vermelho = true
				}
			},
            pagina_atual(val){
                this.MtdCarregaAgendamentos(val);
			},		
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.MtdLocalizarProduto(this.vcoddigedicao);					
                }
			},		
			vdescacresedicao(){
				this.MtdTpDescAcres(this.vtipodescacresedicao);
			},
			vtipodescacresedicao(val) {
				this.MtdTpDescAcres(val);
        	},
			vtipodescontoservicoedicao(val){
				if (val == 0){
					this.vtitdescserv = 'Descto.(%):';
				}else{
					this.vtitdescserv = 'Descto.(R$):';
				}			
			},
			vtipodesctotal(){
				this.vfatordescontototal 	= 0;
				this.vresdesconto			= 0;
				this.vtotalcomdesconto 		= this.vtotalsemdesconto;
			},
			vachouPro(){
                this.vfaltaitens = true

                for (var i = 0; i < this.lstitensconf.length; i++) {									
                    if(this.lstitensconf[i]['qtdfalta'] > 0){
                        this.vfaltaitens = false
                        break
                    }
                }
                if(this.vfaltaitens){
                    this.vfinalizado = true
                    this.ativadesativacod = true
                    this.videscpro = ''
                    this.$nextTick(function () {
                        $("#btngravar").focus()
                    })              
                }
			},
        }
    }
</script>
<style>
    @media (max-width: 576px) {

        .grafico-line .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
     
        .grafico-line .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        
        .grafico-line .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }
    @media print{
        .grafico-line .echarts{
            width: 1024px;
            height: 400px;  
            margin: 0;      
        }    
    }   
    .nrfor{
        width: 30px !important;
    }
    .def-col-cod{
        width: 100px !important;
    }
    .def-col-opcoes-compra{
        width: 150px !important;
    }
	.def-col-nragendamento{
		width: 150px !important;
	}
    .def-col-situacao{
        width: 90px !important;
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-aguardando{
        background: #EEA435!important;
        color: white;
    }
    .bdg-entregue{
        background: #5A956A!important;
    }
    .bdg-cancelado{
        background: #cc330d!important;
    }
    .bgdigitacao{
        background: #6BA2D0!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgaguardando{
        background: #EEA435!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgentregue{
        background: #5A956A!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgcancelados{
        background: #cc330d!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .dgl{
        background: #6BA2D0!important;
    }
    .agl{
        background: #EEA435!important;
    }
    .enl{
        background: #5A956A!important;
    }
    .cal{
        background: #cc330d!important;
    }
    
</style>